<template>
<div class="col-md-12" style="height: 100%;">
    <div class="row" style="padding-top: 15px; padding-bottom: 15px; margin-bottom: 15px; border-bottom: 1px solid #ddd;">
        <div class="col-md-12">
            <div class="pull-left clearfix" style="width: calc(100% - 225px);">
                <div class="pull-left" style="margin-right: 15px;">
                    <h1 class="rcss-heading-1" style="cursor: pointer;"><i style="font-size: 36px;" class="fa fa-angle-left" @click="$emit('onBackClick')"></i></h1>
                </div>
                <div class="pull-left" style="width: calc(100% - 45px);">
                    <h4 class="rcss-heading-4">
                        <span>{{$parent._getTitleByType(content.Type, content)}}</span>
                        <template>
                            <template v-if="content.IsInitiated && content.IsInitiateOnlySectionType && content.Type == 'Evaluation' && content.Evaluation.SectionStatus == 'Completed' && content.Evaluation.SignedDocument != null">
                                <span class="label label-success rcss-label-success">Completed & Signed {{IsPhysically(content.SignatureType)}} Form I-983</span>
                            </template>
                             <template v-else-if="content.IsInitiated && content.IsInitiateOnlySectionType && content.Type == 'MaterialChange' && content.Employer.SectionStatus == 'Completed' && showCollapse('Employer') && !IsMultipleMaterialChange() && content.Employer.SignedDocument != null">
                                <span class="label label-success rcss-label-success">Completed & Signed {{IsPhysically(content.SignatureType)}} Form I-983</span>
                            </template>
                            <template v-else-if="content.IsInitiated && content.IsInitiateOnlySectionType && content.Type == 'MaterialChange' && content.AssignedTraining.SectionStatus == 'Completed' && showCollapse('Training') && !IsMultipleMaterialChange() && content.AssignedTraining.SignedDocument != null">
                                <span class="label label-success rcss-label-success">Completed & Signed {{IsPhysically(content.SignatureType)}} Form I-983</span>
                            </template>
                            <template v-else-if="content.Status == 'Completed'">
                                <span class="label label-success rcss-label-success">Completed & Signed {{IsPhysically(content.SignatureType)}} Form I-983</span>
                            </template>
                            <template v-else-if="$parent.isStudentEvaluationPending(content)">
                                <span class="label label-warning">Pending Student Evaluation</span>
                            </template>
                            <template v-else-if="$parent.isMaterialChangeInComplete(content)">
                                <span class="label label-warning">Incomplete</span>
                            </template>
                            <template v-else-if="$parent.isPhysicalSignaturePending(content)">
                                <span class="label label-warning">Pending {{IsPhysically(content.SignatureType)}} Signature</span>
                            </template>
                            <template v-else>
                                <span class="label label-warning">Pending</span>
                            </template>
                        </template>
                    </h4>
                    <p class="rcss-para" style="margin-bottom: 0;">
                         <span >Initiated Date: {{InitiatedDate}} </span>
                        <span v-if="InitiatedBy != '' && InitiatedBy != '-'">| Initiated By: {{InitiatedBy}} </span>
                        <span v-if="content.SignatureType == 'Electronic'">| Signature Method: Electronic </span>
                        <span v-else>| Signature Method: Ink </span>

                         <br>
                        <span v-if="EvaluationStatus">
                             Evaluation Period: {{Evaluation.EvaluationFrom}} to {{Evaluation.EvaluationTo}}  <span v-if="CompletedDate != '' && CompletedDate != '-'"> | </span>
                        </span>
                        <span v-if="CompletedDate != '' && CompletedDate != '-'"> Completed Date: {{CompletedDate}}   </span>

                        <shared-log :logs="completeSharedLog" v-if="completeSharedLog && completeSharedLog.length > 0"></shared-log>
                    </p>
                </div>
            </div>
            <div class="pull-right clearfix text-right">
                <template v-if="!content.IsInitiated">
                        <ob-button v-if="content.Status == 'DocumentPending'  || content.Status == 'SignaturePending'" type="primary" @click="_showUploadSignedFormPopupForUpload('I983')"  key="uploadSignedI983Btn">Upload Signed I-983</ob-button>
                        <ob-button v-else-if="content.Status == 'Completed'" type="primary"  @click="$parent.onShare(content.Id, 'CompleteForm', false, content.SignedDocument)" key="shareSignedI983Btn">Share Signed I-983</ob-button>
                </template>
                <template v-else-if="content.Status == 'Completed' || $parent.isPhysicalSignaturePending(content)">
                    <template v-if="content.IsInitiateOnlySectionType && !IsMultipleMaterialChange()">
                        <template v-if="content.Type == 'Evaluation' && Evaluation.SectionStatus == 'Completed'">
                            <ob-button  v-if="IsSignedDocumentForEvaluationExist" type="primary"  @click="$parent.onShare(content.Id, 'Evaluation', true)" key="shareSignedI983Btn">Share Signed I-983</ob-button>
                            <ob-dropdown  title="Actions" class="list-action-dropdown">
                                        <ob-dropdown-list-item @click.native="$parent.ViewOrDownloadDocument(content.Id, 'Evaluation', false)">Preview Complete Form</ob-dropdown-list-item>
                                        <ob-dropdown-list-item v-if="IsSignedDocumentForEvaluationExist" @click.native="ViewSignedDocument(SignedDocumentUrlForEvalution)">View Complete Document</ob-dropdown-list-item>
                                        <ob-dropdown-list-item v-if="IsSignedDocumentForEvaluationExist" @click.native="DownloadSignedDocument(SignedDocumentUrlForEvalution)"> Download Complete Document</ob-dropdown-list-item>
                                        <ob-dropdown-list-item v-if="IsSignedDocumentForEvaluationExist" @click.native="$parent.onShare(content.Id, 'Evaluation',true)"> Share Complete Document</ob-dropdown-list-item>
                                        <ob-dropdown-list-item v-if="$parent.showDeleteAction(content.CreatedBy.Email)" @click.native="$emit('deleteForm', content.Id)">Delete Complete Form</ob-dropdown-list-item>
                            </ob-dropdown>
                        </template>
                        <template v-else-if="content.Type == 'MaterialChange' && Employer.SectionStatus == 'Completed' && showCollapse('Employer')">
                            <ob-button  v-if="IsSignedDocumentForEmployerExist" type="primary"  @click="$parent.onShare(content.Id, 'Employer', true)" key="shareSignedI983Btn">Share Signed I-983</ob-button>
                            <ob-dropdown  title="Actions" class="list-action-dropdown">
                                        <ob-dropdown-list-item @click.native="$parent.ViewOrDownloadDocument(content.Id, 'Employer', false)">Preview Complete Form</ob-dropdown-list-item>
                                        <ob-dropdown-list-item v-if="IsSignedDocumentForEmployerExist" @click.native="ViewSignedDocument(SignedDocumentUrlForEmployer)">View Complete Document</ob-dropdown-list-item>
                                        <ob-dropdown-list-item v-if="IsSignedDocumentForEmployerExist" @click.native="DownloadSignedDocument(SignedDocumentUrlForEmployer)"> Download Complete Document</ob-dropdown-list-item>
                                        <ob-dropdown-list-item v-if="IsSignedDocumentForEmployerExist" @click.native="$parent.onShare(content.Id, 'Employer',true)"> Share Complete Document</ob-dropdown-list-item>
                                        <ob-dropdown-list-item v-if="$parent.showDeleteAction(content.CreatedBy.Email)" @click.native="$emit('deleteForm', content.Id)">Delete Complete Form</ob-dropdown-list-item>
                            </ob-dropdown>
                        </template>
                         <template v-else-if="content.Type == 'MaterialChange' && AssignedTraining.SectionStatus == 'Completed'  && showCollapse('Training')">
                            <ob-button  v-if="IsSignedDocumentForAssignedTrainingExist" type="primary"  @click="$parent.onShare(content.Id, 'AssignedTraining', true)" key="shareSignedI983Btn">Share Signed I-983</ob-button>
                            <ob-dropdown  title="Actions" class="list-action-dropdown">
                                        <ob-dropdown-list-item @click.native="$parent.ViewOrDownloadDocument(content.Id, 'AssignedTraining', false)">Preview Complete Form</ob-dropdown-list-item>
                                        <ob-dropdown-list-item v-if="IsSignedDocumentForAssignedTrainingExist" @click.native="ViewSignedDocument(SignedDocumentUrlForAssignedTraining)">View Complete Document</ob-dropdown-list-item>
                                        <ob-dropdown-list-item v-if="IsSignedDocumentForAssignedTrainingExist" @click.native="DownloadSignedDocument(SignedDocumentUrlForAssignedTraining)"> Download Complete Document</ob-dropdown-list-item>
                                        <ob-dropdown-list-item v-if="IsSignedDocumentForAssignedTrainingExist" @click.native="$parent.onShare(content.Id, 'AssignedTraining',true)"> Share Complete Document</ob-dropdown-list-item>
                                        <ob-dropdown-list-item v-if="$parent.showDeleteAction(content.CreatedBy.Email)" @click.native="$emit('deleteForm', content.Id)">Delete Complete Form</ob-dropdown-list-item>
                            </ob-dropdown>
                        </template>
                        <template v-else>
                                <ob-button v-if="$parent.showDeleteAction(content.CreatedBy.Email)" type="secondary" class="js-stop-propagate-class" @click="$emit('deleteForm', content.Id)">Delete Form</ob-button>
                        </template>
                    </template>
                     <template v-else-if="content.IsInitiateOnlySectionType && IsMultipleMaterialChange()">
                        <ob-button type="primary" @click="_showUploadSignedFormPopup('I983')" v-if="$parent.isPhysicalSignaturePending(content)" key="uploadSignedI983Btn">Upload Signed I-983</ob-button>
                        <ob-button type="primary" v-else @click="$parent.onShare(content.Id, 'CompleteForm', false, content.SignedDocument)" key="shareSignedI983Btn">Share Signed I-983</ob-button>
                        <ob-dropdown title="Actions" class="list-action-dropdown">
                            <ob-dropdown-list-item @click.native="$parent.ViewOrDownloadDocument(content.Id, 'EmployerAndTraining', false)">Preview Complete Form</ob-dropdown-list-item>
                            <ob-dropdown-list-item  v-if="content.SignedDocument != null" @click.native="$parent.ViewOrDownloadDocument(content.Id, 'CompleteForm', false, content.SignedDocument)">View Complete Document</ob-dropdown-list-item>
                            <ob-dropdown-list-item  v-if="content.SignedDocument != null" @click.native="$parent.ViewOrDownloadDocument(content.Id, 'CompleteForm', true, content.SignedDocument)">Download Complete Document</ob-dropdown-list-item>
                            <ob-dropdown-list-item  @click.native="$parent.onShare(content.Id, 'CompleteForm', false, content.SignedDocument)">Share Complete Document</ob-dropdown-list-item>
                            <ob-dropdown-list-item v-if="$parent.showDeleteAction(content.CreatedBy.Email)" @click.native="$emit('deleteForm', content.Id)">Delete Complete Form</ob-dropdown-list-item>
                        </ob-dropdown>
                    </template>
                    <template v-else>
                        <ob-button type="primary" @click="_showUploadSignedFormPopup('I983')" v-if="$parent.isPhysicalSignaturePending(content)" key="uploadSignedI983Btn">Upload Signed I-983</ob-button>
                        <ob-button type="primary" v-else @click="$parent.onShare(content.Id, 'CompleteForm', false, content.SignedDocument)" key="shareSignedI983Btn">Share Signed I-983</ob-button>
                        <ob-dropdown title="Actions" class="list-action-dropdown">
                            <ob-dropdown-list-item v-if="content.SignatureType != 'Electronic'" @click.native="$parent.ViewOrDownloadDocument(content.Id, 'CompleteForm', false)">Preview Complete Form</ob-dropdown-list-item>
                            <ob-dropdown-list-item  v-if="content.SignedDocument != null" @click.native="$parent.ViewOrDownloadDocument(content.Id, 'CompleteForm', false, content.SignedDocument)">View Complete Document</ob-dropdown-list-item>
                            <ob-dropdown-list-item  v-if="content.SignedDocument != null" @click.native="$parent.ViewOrDownloadDocument(content.Id, 'CompleteForm', true, content.SignedDocument)">Download Complete Document</ob-dropdown-list-item>
                            <ob-dropdown-list-item  @click.native="$parent.onShare(content.Id, 'CompleteForm', false, content.SignedDocument)">Share Complete Document</ob-dropdown-list-item>
                            <ob-dropdown-list-item v-if="$parent.showDeleteAction(content.CreatedBy.Email)" @click.native="$emit('deleteForm', content.Id)">Delete Complete Form</ob-dropdown-list-item>
                        </ob-dropdown>
                    </template>
                </template>
                 <template v-else>
                    <ob-button v-if="$parent.showDeleteAction(content.CreatedBy.Email)" type="secondary" class="js-stop-propagate-class" @click="$emit('deleteForm', content.Id)">Delete Form</ob-button>
                </template>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">

            <template v-if="content.Status == 'Completed'">
                <ob-collapse :type="4" :expand="false" :disabled="false" theme="primary" v-if="content.SignatureType != 'Electronic'">
                    <template slot="collapse-title">
                        SIGNED FORM I-983 DOCUMENT
                    </template>
                    <template slot="collapse-title-right">
                        <span style="width: 294px; display:inline-block;">
                            <span class="rcss-text-green1"><i class="fa fa-check-circle"></i> Completed</span>
                        </span>
                    </template>
                    <template slot="collapse-details">
                        <div style="transform: translateY(-20px); position: relative; z-index: 1;" v-if="SignedDocumentSharedLogs.length > 0 || SignedDocumentModifiedLogs.length > 1">
                            <modified-log :logs="SignedDocumentModifiedLogs" v-if="SignedDocumentModifiedLogs.length > 1"></modified-log>
                            <span style="width: 20px; display: inline-block;" v-if="SignedDocumentModifiedLogs.length > 1 && SignedDocumentSharedLogs.length  > 0"></span>
                            <shared-log :logs="SignedDocumentSharedLogs" v-if="SignedDocumentSharedLogs.length > 0"></shared-log>
                        </div>
                        <div class="row">

                            <div class="document-list document-list--default">
                                <div  class="document-list__header clearfix">
                                    <div  class="document-list__heading">
                                        <i  aria-hidden="true" class="fa fa-file-text" style="color: #4D92DF"></i>
                                        <span style="font-size: 16px;display: inline-block;width: 400px;" class="document-list__title rcss-truncate"  :title="SignedDocumentFileName">CompleteI983Document.pdf</span>

                                        <div class="form-group" style="margin-top: 15px;padding-left: 31px;">
                                            <label class="control-label">Completed Date</label>
                                            <p class="form-control-static" style="padding: 0;">{{CompletedDate}}</p>
                                        </div>

                                    </div>
                                    <div  class="document-list__controls">
                                        <div class="pull-right clearfix text-right">
                                        <ob-dropdown title="Actions" class="list-action-dropdown">
                                                <ob-dropdown-list-item @click.native="ViewSignedDocument(SignedDocumentUrl)">View Signed Form</ob-dropdown-list-item>
                                                <ob-dropdown-list-item @click.native="_showUploadSignedFormPopupForUpdate('I983')">Update Signed Form</ob-dropdown-list-item>
                                                <ob-dropdown-list-item @click.native="DownloadSignedDocument(SignedDocumentUrl)">Download</ob-dropdown-list-item>
                                                <ob-dropdown-list-item @click.native="$parent.onShare(content.Id, 'SignedForm' ,true)">Share Signed Form</ob-dropdown-list-item>
                                            </ob-dropdown>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </ob-collapse>
            </template>
            <template v-else-if="(content.Status == 'DocumentPending' || content.Status == 'SignaturePending') && !content.IsInitiated">
                <ob-collapse :type="4" :expand="false" :disabled="false" theme="primary">
                    <template slot="collapse-title">
                        SIGNED FORM I-983 DOCUMENT
                    </template>
                     <template slot="collapse-title-right">
                            <span class="rcss-text-warning" style="width: 250px; display:inline-block;"><i class="fa fa-warning"></i> Pending</span>
                    </template>
                    <template slot="collapse-details">
                        <div class="row" v-if="content.SignatureType !='Electronic'">
                            <div class="document-list document-list--default">
                                <div  class="document-list__header clearfix">
                                    <div  class="document-list__heading"><i  aria-hidden="true" class="fa fa-file-text"></i> <span  class="document-list__title"> Upload Signed form I-983 document </span></div><i style="margin-top: 13px;" class="fa fa-info-circle" v-tooltip="'Please upload the physically Signed Form I-983 Document.'"></i>
                                    <div  class="document-list__controls">
                                        <ob-button type="primary" :disabled="false"  @click="_showUploadSignedFormPopupForUpload('I983')"  key="uploadSignedI983Btn">Upload</ob-button>
                                    </div>
                                </div>
                            </div>     
                        </div>
                    </template>
                </ob-collapse>
            </template>
            <template v-if="IsMaterialChange">
                <ob-collapse :type="4" :expand="false" :disabled="false" theme="primary">
                    <template slot="collapse-title">
                        MATERIAL CHANGE
                    </template>
                    <template slot="collapse-title-right">
                        <template v-if="content.MaterialChange.SectionStatus == 'InComplete'">
                             <span v-if=" content.Status != 'Completed'" class="rcss-text-warning" style="width: 253px; display:inline-block;"><i  class="fa fa-warning"></i> Pending</span>
                            <!-- <ob-button type="primary" @click="showInitiateMaterialChangePopupForUpdate = true; showInitiateMaterialChangePopup = true;IsCompleteButton = true" style="margin-right: 10px; width: 90px;visibility: hidden">Complete</ob-button> -->
                        </template>
                        <template v-else-if="IsSupervisor">
                            <ob-dropdown type="ellipsis">
                                <ob-dropdown-list-item @click.native="showInitiateMaterialChangePopupForUpdate = true; showInitiateMaterialChangePopup = true;">Update Material Change</ob-dropdown-list-item>
                            </ob-dropdown>
                        </template>
                    </template>
                    <template slot="collapse-details">
                        <div class="col-md-12 pL0" v-if="content.MaterialChange.SectionStatus == 'InComplete'">
                            <div class="form-group">
                                <p class="complete_style">This material change information is incomplete.<ob-button type="link" class="complete_button" @click="showInitiateMaterialChangePopupForUpdate = true; showInitiateMaterialChangePopup = true;IsCompleteButton = true">Complete now</ob-button></p>
                            </div>
                        </div>
                         <div style="transform: translateY(-20px); position: relative; z-index: 1;" v-if="content.MaterialChange && content.MaterialChange.ModifiedLogs && content.MaterialChange.ModifiedLogs.length > 1">
                            <modified-log :logs="content.MaterialChange && content.MaterialChange.ModifiedLogs"></modified-log>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label">Material Change Initiated Date</label>
                                    <p class="form-control-static">{{InitiatedDate}}</p>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label">Material Change<template v-if="content.MaterialChange.MaterialChangeType && content.MaterialChange.MaterialChangeType.length > 1">s</template></label>
                                    <p class="form-control-static" v-if="content.MaterialChange.MaterialChangeType && content.MaterialChange.MaterialChangeType.length > 0">
                                      <ol style="padding-left: 15px; margin: 0;">
                                          <li v-for="(m, index) in content.MaterialChange.MaterialChangeType" :key="index" style="margin-bottom: 15px;">
                                              <span v-if="m == 'ChangeOfEmployerIdentificationNumber'">Change of the employer’s Employer Identification Number (i.e., the company’s Federal Tax ID number)</span>
                                              <span v-else-if="m == 'ReductionInStudentCompensation'">Reduction in student compensation that is not tied to a reduction in hours worked</span>
                                              <span v-else-if="m == 'DecreaseInHoursPerweek'">Significant decrease in hours per week that a student engages in a STEM training opportunity</span>
                                              <span v-else-if="m == 'ChangesCommitmentsOrObjectives'">Changes to the employer’s commitments or student’s learning objectives as documented on the Form I-983</span>
                                              <span v-else-if="m == 'PeriodicEvaluationFromTheUniversity'">Periodic evaluation from  the University</span>
                                              <span v-else-if="m == 'ChangeInEmployerSite'">Change in employer site</span>
                                              <span v-else-if="m == 'Others'" style="word-break: break-all;">Others ({{NAOrValue(content.MaterialChange, 'SpecifyReason')}})</span>
                                          </li>
                                      </ol>
                                    </p>
                                    <p class="form-control-static" v-else>N/A</p>
                                </div>
                            </div>
                        </div>

                       <div class="row" v-if="_HasMaterialChangeType('ChangeOfEmployerIdentificationNumber')  || _HasMaterialChangeType('PeriodicEvaluationFromTheUniversity') || _HasMaterialChangeType('Others')">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label">Employer ID Number (EIN)</label>
                                    <p class="form-control-static">{{NAOrValue(content.MaterialChange, 'EIN')}}</p>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="_HasMaterialChangeType('ReductionInStudentCompensation') || _HasMaterialChangeType('PeriodicEvaluationFromTheUniversity') || _HasMaterialChangeType('Others')">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="control-label">Salary Amount</label>
                                    <p class="form-control-static">$ {{NAOrValue(content.MaterialChange, 'Salary')}}</p>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="control-label">Salary Frequency</label>
                                    <p class="form-control-static">{{_getHumanSalaryFrequency(NAOrValue(content.MaterialChange, 'SalaryFrequency'))}}</p>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="_HasMaterialChangeType('DecreaseInHoursPerweek') || _HasMaterialChangeType('ReductionInStudentCompensation')  || _HasMaterialChangeType('PeriodicEvaluationFromTheUniversity') ||  _HasMaterialChangeType('Others')">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label">OPT Hours Per Week</label>
                                    <p class="form-control-static">{{NAOrValue(content.MaterialChange, 'OPTHours')}}</p>
                                </div>
                            </div>
                        </div>
                         <div class="row" v-if="_HasMaterialChangeType('ChangeInEmployerSite') || _HasMaterialChangeType('Others')">
                            <div class="col-md-12">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label class="control-label">Site Name</label>
                                        <p class="form-control-static">{{NAOrValue(AssignedTraining, 'SiteName')}}</p>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label class="control-label">Site Address (Street, City, State, ZIP)</label>
                                        <p class="form-control-static">{{NAOrValue(AssignedTraining, 'SiteAddress')}}</p>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label class="control-label">Name of Official</label>
                                        <p class="form-control-static">{{NAOrValue(Employer.SignatoryAuthority, 'Name')}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label class="control-label">Official's Title</label>
                                        <p class="form-control-static">{{NAOrValue(Employer.SignatoryAuthority, 'Title')}}</p>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label class="control-label">Official's Email</label>
                                        <p class="form-control-static">{{NAOrValue(Employer.SignatoryAuthority, 'Email')}}</p>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label class="control-label">Official's Phone Number</label>
                                        <p class="form-control-static">{{NAOrValue(Employer.SignatoryAuthority, 'Phone')}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="_HasMaterialChangeType('ChangesCommitmentsOrObjectives')  || _HasMaterialChangeType('PeriodicEvaluationFromTheUniversity') ||  _HasMaterialChangeType('Others')">
                            <div class="col-md-12 training_plan_border">
                                <div class="form-group">
                                    <label class="control-label">Training Plan Title</label>
                                    <p class="form-control-static">{{NAOrValue(content.MaterialChange.Training, 'Title')}}</p>
                                </div>
                            </div>
                            <div class="col-md-12 training_plan_border">
                                <div class="form-group">
                                    <label class="control-label">Student Role: Describe the student's role with the employer and how that role is directly related to enhancing the student's knowledge obtained through his or her qualifying STEM degree.</label>
                                    <p class="form-control-static">{{NAOrValue(content.MaterialChange.Training, 'StudentRole')}}</p>
                                </div>
                            </div>
                            <div class="col-md-12 training_plan_border">
                                <div class="form-group">
                                    <label class="control-label">Goals and Objectives: Describe how the assignment(s) with the employer will help the student achieve his or her specific objectives for workbased learning related to his or her STEM degree. The description must both specify the student's goals regarding specific knowledge, skills, or techniques as well as the means by which they will be achieved.</label>
                                    <p class="form-control-static">{{NAOrValue(content.MaterialChange.Training, 'Objectives')}}</p>
                                </div>
                            </div>
                            <div class="col-md-12 training_plan_border">
                                <div class="form-group">
                                    <label class="control-label">Employer Oversight: Explain how the employer provides oversight and supervision of individuals filling positions such as that being filled by the named F-1 student. If the employer has a training program or related policy in place that controls such oversight and supervision, please describe.</label>
                                    <p class="form-control-static">{{NAOrValue(content.MaterialChange.Training, 'EmployerOverSight')}}</p>
                                </div>
                            </div>
                            <div class="col-md-12 training_plan_border">
                                <div class="form-group">
                                    <label class="control-label">Measures and Assessments· Explain how the employer measures and confirms whether individuals filling positions such as that being filled by the named F-1 student are acquiring new knowledge and skills. If the employer has a training program or related policy in place that controls such measures and assessments, please describe.</label>
                                    <p class="form-control-static">{{NAOrValue(content.MaterialChange.Training, 'Assessments')}}</p>
                                </div>
                            </div>
                            <div class="col-md-12 training_plan_border">
                                <div class="form-group">
                                    <label class="control-label">Additional Remarks</label>
                                    <p class="form-control-static">{{NAOrValue(content.MaterialChange.Training, 'AdditionalRemarks')}}</p>
                                </div>
                            </div>
                        </div>
                    </template>
                </ob-collapse>
            </template>
            <template v-if="EvaluationStatus">
                <ob-collapse :type="4" :expand.sync="evaluationExpand" :disabled="false" :theme="evaluationTheme">
                    <template slot="collapse-title">
                        EVALUATION ON STUDENT PROGRESS <template v-if="Evaluation.IsFinalEvalution">(Final Evaluation)</template>
                    </template>
                    <template slot="collapse-title-right">
                        <template v-if="IsSupervisor && IsSameEvaluationHRAndSignatoryAuthority">
                            <template v-if ="showVerifyButton" >
                                <span class="rcss-text-warning" style="width: 250px; display:inline-block;"><i class="fa fa-warning"></i> Pending Verification</span>
                                <ob-button type="primary" @click="showInitiateStudentEvaluationPopupForUpdate = false;showInitiateStudentEvaluationPopup = true;" style="margin-right: 10px; width: 120px;">Verify Evaluation</ob-button>
                            </template>
                            <template v-else>
                                <template v-if="evaluationExpand && Evaluation.SectionStatus == 'Completed'">
                                    <span v-if="Evaluation.SectionStatus == 'PendingFromStudent'" class="rcss-text-warning" style="width: 250px; display:inline-block;"><i class="fa fa-warning"></i> Pending from Student</span>
                                    <span v-else class="rcss-text-green1" style="width: 250px; display:inline-block;"><i class="fa fa-check-circle"></i> {{Evaluation.SectionStatus}}</span>
                                    <ob-dropdown type="ellipsis">
                                        <ob-dropdown-list-item @click.native="$parent.ViewOrDownloadDocument(content.Id, 'Evaluation', false)"> Preview in Form</ob-dropdown-list-item>
                                        <ob-dropdown-list-item @click.native="showInitiateStudentEvaluationPopupForUpdate = true;showInitiateStudentEvaluationPopup = true;">Update</ob-dropdown-list-item>
                                        <ob-dropdown-list-item v-if="IsSignedDocumentForEvaluationExist" @click.native="DownloadSignedDocument(SignedDocumentUrlForEvalution)"> Download</ob-dropdown-list-item>
                                    </ob-dropdown>
                                </template>
                                <template v-else>
                                    <span v-if="Evaluation.SectionStatus == 'PendingFromStudent'" class="rcss-text-warning" style="width: 250px; display:inline-block;"><i class="fa fa-warning"></i> Pending from Student</span>
                                    <span v-else class="rcss-text-green1" style="width: 250px; display:inline-block;"><i class="fa fa-check-circle"></i> {{Evaluation.SectionStatus}}</span>
                                    <ob-dropdown type="ellipsis">
                                        <ob-dropdown-list-item @click.native="$parent.ViewOrDownloadDocument(content.Id, 'Evaluation', false)"> Preview in Form</ob-dropdown-list-item>
                                        <ob-dropdown-list-item v-if="IsSignedDocumentForEvaluationExist" @click.native="ViewSignedDocument(SignedDocumentUrlForEvalution)">View Signed Socument</ob-dropdown-list-item>
                                        <ob-dropdown-list-item v-if="IsSignedDocumentForEvaluationExist" @click.native="DownloadSignedDocument(SignedDocumentUrlForEvalution)"> Download Signed Document</ob-dropdown-list-item>
                                        <ob-dropdown-list-item @click.native="showInitiateStudentEvaluationPopupForUpdate = true;showInitiateStudentEvaluationPopup = true;">Update Form</ob-dropdown-list-item>
                                        <ob-dropdown-list-item v-if="IsSignedDocumentForEvaluationExist" @click.native="$parent.onShare(content.Id, 'Evaluation',true)"> Share Signed Document</ob-dropdown-list-item>
                                        <ob-dropdown-list-item v-if="content.SignatureType == 'Electronic' && IsSignedDocumentForEvaluationExist" @click.native="DownloadSignatureCertificate(content.Evaluation.SignatureCertificate,'Evaluation')">View Signature Certificate</ob-dropdown-list-item>
                                    </ob-dropdown>
                                </template>
                             </template>
                        </template>
                        <template v-else>
                        <template v-if="Evaluation.SectionStatus == 'PendingFromStudent'">
                            <template v-if="isHRManager || IsSupervisor">
                                <span class="rcss-text-warning" style="width: 250px; display:inline-block;"><i class="fa fa-warning"></i> Pending from Student</span>
                                 <ob-dropdown type="ellipsis">
                                    <ob-dropdown-list-item @click.native="$parent.ViewOrDownloadDocument(content.Id, 'Evaluation', false)"> Preview in Form</ob-dropdown-list-item>
                                    <ob-dropdown-list-item v-if="IsSignedDocumentForEvaluationExist" @click.native="ViewSignedDocument(SignedDocumentUrlForEvalution)">View Signed Document</ob-dropdown-list-item>
                                    <ob-dropdown-list-item v-if="IsSignedDocumentForEvaluationExist" @click.native="DownloadSignedDocument(SignedDocumentUrlForEvalution)"> Download Signed Document</ob-dropdown-list-item>
                                    <ob-dropdown-list-item @click.native="showInitiateStudentEvaluationPopupForUpdate = true;showInitiateStudentEvaluationPopup = true;">Update Form</ob-dropdown-list-item>
                                    <ob-dropdown-list-item v-if="IsSignedDocumentForEvaluationExist" @click.native="$parent.onShare(content.Id, 'Evaluation',true)"> Share Signed Document</ob-dropdown-list-item>
                                    <ob-dropdown-list-item v-if="content.SignatureType == 'Electronic' && IsSignedDocumentForEvaluationExist" @click.native="DownloadSignatureCertificate(content.Evaluation.SignatureCertificate,'Evaluation')">View Signature Certificate</ob-dropdown-list-item>
                                </ob-dropdown>
                            </template>
                            <template v-else>
                                <span class="rcss-text-warning" style="width: 290px; display:inline-block;"><i class="fa fa-warning"></i> Pending Evaluation</span>
                                <!-- <ob-button type="primary" @click="showInitiateStudentEvaluationPopupForUpdate = false;showInitiateStudentEvaluationPopup = true;" style="margin-right: 10px; width: 90px;">Complete</ob-button> -->
                            </template>
                        </template>
                         <template v-else-if="Evaluation.SectionStatus == 'InComplete'">
                            <template v-if="content.Status != 'Completed' && content.IsInitiated">
                                <span class="rcss-text-warning" style="width: 290px; display:inline-block;"><i class="fa fa-warning"></i> Pending</span>
                            </template>
                            <template  v-if="content.Status != 'Completed' && !content.IsInitiated">
                                <span class="rcss-text-warning" style="width: 253px; display:inline-block;"><i class="fa fa-warning"></i> Pending</span>
                            </template>
                            <!-- <ob-button v-if ="!IsSupervisor" type="primary" @click="showInitiateStudentEvaluationPopupForUpdate = true;showInitiateStudentEvaluationPopup = true;IsCompleteButton = true" style="margin-right: 10px; width: 90px;">Complete</ob-button> -->
                        </template>
                        <template v-else>
                            <template v-if="evaluationExpand && Evaluation.SectionStatus == 'Completed'">
                                <span class="rcss-text-warning" style="width: 250px; display:inline-block;" v-if="Evaluation.SignedDocument == null && Evaluation.SignedDocumentStatus != ''"><i class="fa fa-warning"></i> {{handleEvaluationStatus(Evaluation)}}</span>
                                <span class="rcss-text-green1" style="width: 250px; display:inline-block;" v-else><i class="fa fa-check-circle"></i> {{Evaluation.SectionStatus}}</span>
                                <ob-dropdown type="ellipsis">
                                    <ob-dropdown-list-item @click.native="$parent.ViewOrDownloadDocument(content.Id, 'Evaluation', false)"> Preview in Form</ob-dropdown-list-item>
                                    <ob-dropdown-list-item @click.native="showInitiateStudentEvaluationPopupForUpdate = true;showInitiateStudentEvaluationPopup = true;">Update</ob-dropdown-list-item>
                                    <ob-dropdown-list-item v-if="IsSignedDocumentForEvaluationExist" @click.native="DownloadSignedDocument(SignedDocumentUrlForEvalution)"> Download</ob-dropdown-list-item>
                                </ob-dropdown>
                            </template>
                            <template v-else>
                                <span class="rcss-text-warning" style="width: 250px; display:inline-block;" v-if="Evaluation.SignedDocument == null && Evaluation.SignedDocumentStatus != ''"><i class="fa fa-warning"></i> {{handleEvaluationStatus(Evaluation)}}</span>
                                <span class="rcss-text-green1" style="width: 250px; display:inline-block;" v-else><i class="fa fa-check-circle"></i> {{Evaluation.SectionStatus}}</span>
                                <ob-dropdown type="ellipsis">
                                    <ob-dropdown-list-item @click.native="$parent.ViewOrDownloadDocument(content.Id, 'Evaluation', false)"> Preview in Form</ob-dropdown-list-item>
                                    <ob-dropdown-list-item v-if="IsSignedDocumentForEvaluationExist" @click.native="ViewSignedDocument(SignedDocumentUrlForEvalution)">View Signed Document</ob-dropdown-list-item>
                                    <ob-dropdown-list-item v-if="IsSignedDocumentForEvaluationExist" @click.native="DownloadSignedDocument(SignedDocumentUrlForEvalution)"> Download Signed Document</ob-dropdown-list-item>
                                    <ob-dropdown-list-item @click.native="showInitiateStudentEvaluationPopupForUpdate = true;showInitiateStudentEvaluationPopup = true;">Update Form</ob-dropdown-list-item>
                                    <ob-dropdown-list-item v-if="IsSignedDocumentForEvaluationExist" @click.native="$parent.onShare(content.Id, 'Evaluation',true)"> Share Signed Document</ob-dropdown-list-item>
                                    <ob-dropdown-list-item v-if="content.SignatureType == 'Electronic' && IsSignedDocumentForEvaluationExist" @click.native="DownloadSignatureCertificate(content.Evaluation.SignatureCertificate,'Evaluation')">View Signature Certificate</ob-dropdown-list-item>
                                </ob-dropdown>
                            </template>
                        </template>
                      </template>
                    </template>
                    <template slot="collapse-details">
                        <div class="col-md-12 pL0" v-if="Evaluation.SectionStatus == 'PendingFromStudent' && !IsSupervisor">
                            <div class="form-group">
                                <p class="complete_style">The Student Evaluation information is incomplete. <ob-button type="link" class="complete_button" @click="showInitiateStudentEvaluationPopupForUpdate = false;showInitiateStudentEvaluationPopup = true;" > Complete now</ob-button></p>
                            </div>
                        </div>
                        <div class="col-md-12 pL0" v-else-if="Evaluation.SectionStatus == 'InComplete' && !IsSupervisor">
                            <div class="form-group">
                                <p class="complete_style">The Student Evaluation information is incomplete. <ob-button type="link" class="complete_button" @click="showInitiateStudentEvaluationPopupForUpdate = true;showInitiateStudentEvaluationPopup = true;IsCompleteButton = true" > Complete now</ob-button></p>
                            </div>
                        </div>

                        <div style="transform: translateY(-20px); position: relative; z-index: 1;" v-if="EvalutionSharedLog.length > 0 || Evaluation.ModifiedLogs.length > 1">
                            <modified-log :logs="Evaluation.ModifiedLogs" v-if="Evaluation.ModifiedLogs.length > 1"></modified-log>
                            <span style="width: 20px; display: inline-block;" v-if="Evaluation.ModifiedLogs.length > 1 && Evaluation.ModifiedLogs.length  > 0"></span>
                            <shared-log :logs="EvalutionSharedLog" v-if="EvalutionSharedLog.length > 0"></shared-log>
                        </div>

                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="control-label">Student Name</label>
                                    <p class="form-control-static">{{NAOrValue(Employee, 'Name')}}</p>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="control-label">Student Email Address</label>
                                    <p class="form-control-static">{{NAOrValue(Employee, 'Email')}}</p>
                                </div>
                            </div>
                           
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="control-label">Signatory Authority Name</label>
                                    <p class="form-control-static">{{NAOrValue(Evaluation.SignatoryAuthority, 'Name')}}</p>

                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="control-label">Signatory Authority Email</label>
                                    <p class="form-control-static">{{NAOrValue(Evaluation.SignatoryAuthority, 'Email')}}</p>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="control-label">Range of Evaluation Date(From)</label>
                                    <p class="form-control-static">{{NAOrValue(Evaluation, 'EvaluationFrom')}}</p>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="control-label">Range of Evaluation Date(To)</label>
                                    <p class="form-control-static">{{NAOrValue(Evaluation, 'EvaluationTo')}}</p>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label">Evaluation Summary</label>
                                    <p class="form-control-static">{{NAOrValue(Evaluation, 'EvaluationSummary')}}</p>
                                </div>
                            </div>
                        </div>
                        <template v-if="IsSignedDocumentForEvaluationExist && content.SignatureType != 'Electronic'">



                        <div class="document-list document-list--default">
                            <div  class="document-list__header clearfix">
                                <div  class="document-list__heading">
                                    <i  aria-hidden="true" class="fa fa-file-text" style="color: #4D92DF"></i>
                                    <span style="font-size: 16px;display: inline-block;width: 400px;" class="document-list__title rcss-truncate"  :title="SignedDocumentFileNameForEvalution">{{SignedDocumentFileNameForEvalution}}</span>

                                    <div style="margin-top: 5px;margin-left: 30px;font-weight: 500; z-index: 1;"  v-if="EvaluationSignedDocumentSharedLogs.length > 0 || EvaluationSignedDocumentModifiedLogs.length > 1">
                                       <modified-log :logs="EvaluationSignedDocumentModifiedLogs" v-if="EvaluationSignedDocumentModifiedLogs.length > 1"></modified-log>
                                                <span style="width: 20px; display: inline-block;" v-if="EvaluationSignedDocumentModifiedLogs.length > 1 && EvaluationSignedDocumentSharedLogs.length  > 0"></span>
                                                <shared-log :logs="EvaluationSignedDocumentSharedLogs" v-if="EvaluationSignedDocumentSharedLogs.length > 0"></shared-log>
                                    </div>

                                    <div class="form-group" style="margin-top: 15px;padding-left: 31px;">
                                        <label class="control-label">Completed Date</label>
                                        <p class="form-control-static" style="padding: 0;">{{CompletedDateForEvalution}}</p>
                                    </div>

                                </div>
                                <div  class="document-list__controls">
                                    <div class="pull-right clearfix text-right">
                                    <ob-dropdown title="Actions" class="list-action-dropdown">
                                                <ob-dropdown-list-item @click.native="ViewSignedDocument(SignedDocumentUrlForEvalution)">View Signed Form</ob-dropdown-list-item>
                                                <ob-dropdown-list-item @click.native="_showUploadSignedFormPopupForUpdate('I983Evaluation')">Update Signed Form</ob-dropdown-list-item>
                                                <ob-dropdown-list-item @click.native="DownloadSignedDocument(SignedDocumentUrlForEvalution)">Download</ob-dropdown-list-item>
                                                <ob-dropdown-list-item @click.native="$parent.onShare(content.Id, 'Evaluation' ,true)">Share Signed Form</ob-dropdown-list-item>
                                    </ob-dropdown>
                                </div>
                                </div>
                            </div>
                        </div>
                         </template>
                         <div v-else class="row">

                               <div class="document-list document-list--default" v-if="content.SignatureType !='Electronic'">
                                <div  class="document-list__header clearfix">
                                    <div  class="document-list__heading"><i  aria-hidden="true" class="fa fa-file-text"></i> <span  class="document-list__title">Physically Signed Student Evaluation</span></div><i style="margin-top: 13px;" class="fa fa-info-circle" v-tooltip="'Please upload the physically signed Student Evaluation.'"></i>
                                    <div  class="document-list__controls">
                                        <ob-button type="primary" :disabled="Evaluation.SectionStatus != 'Completed'" @click="_showUploadSignedFormPopup('I983Evaluation')"  key="uploadSignedI983Btn">Upload</ob-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </ob-collapse>
             <div v-if="content.Evaluation.SectionStatus == 'PendingFromStudent' && content.SignatureType == 'Electronic' && IsSameEvaluationHRAndSignatoryAuthority"  style="display: flex; align-items: center; justify-content: space-between; background-color:#f6d3d3 ;margin-top: -16px; margin-bottom: 15px; padding: 10px 23px;">
                <p class="complete_style" style="font-size: 12px;  margin-bottom: 0;">
                    Once the Student completes the section, you will need to review and sign it.
                </p>
                <div style="margin-left: 10px;">
                    <ob-button type="secondary" v-if="isInitiatedByLoggedInUser" @click.native="SignatoryChange('Evaluation')">Change Signatory Authority</ob-button>
                </div>
             </div>
             <div v-else-if="content.Evaluation.SignedDocumentStatus == 'Pending Physical Signature' && content.SignatureType == 'Electronic' && IsSameEvaluationHRAndSignatoryAuthority"  style="display: flex; align-items: center; justify-content: space-between; background-color:#f6d3d3 ;margin-top: -16px; margin-bottom: 15px; padding: 10px 23px;">
                <p class="complete_style" style="font-size: 12px;  margin-bottom: 0;">
                    This section is incomplete. Please complete it at your earliest convenience.
                </p>
                <div style="margin-left: 10px;">
                    <ob-button type="secondary" v-if="isInitiatedByLoggedInUser" @click.native="SignatoryChange('Evaluation')">Change Signatory Authority</ob-button>
                    <!-- <ob-button type="primary"  @click="showInitiateStudentEvaluationPopupForUpdate = true;showInitiateStudentEvaluationPopup = true;IsCompleteButton = true">Start Reviewing</ob-button> -->
                </div>
             </div>
            </template>
            
            <ob-collapse v-if="showCollapse('Student')" :type="4" :expand.sync="studentInfoExpand" :disabled="false" :theme="studentInfoTheme">
                <template slot="collapse-title">
                    STUDENT INFORMATION (SECTION 1 &amp; 2)
                </template>
                <template slot="collapse-title-right">
                    <template v-if="Employee.SectionStatus == 'PendingFromStudent'">
                        <template v-if="isHRManager || IsSupervisor">
                            <span class="rcss-text-warning" style="width: 290px; display:inline-block;"><i class="fa fa-warning"></i> Pending From Student</span>
                            <ob-dropdown type="ellipsis" v-if="isHRManager">
                                <ob-dropdown-list-item @click.native="$parent.ViewOrDownloadDocument(content.Id, 'Student', false)">Preview in Form</ob-dropdown-list-item>
                                <ob-dropdown-list-item v-if="IsSignedDocumentForStudentExist" @click.native="ViewSignedDocument(SignedDocumentUrlForStudent)">View Signed Document</ob-dropdown-list-item>
                                <ob-dropdown-list-item v-if="IsSignedDocumentForStudentExist" @click.native="DownloadSignedDocument(SignedDocumentUrlForStudent)">Download Signed Document</ob-dropdown-list-item>
                                <ob-dropdown-list-item @click.native="showInitiateStudentInformationPopupForUpdate = true;showInitiateStudentInformationPopup = true;">Update Form</ob-dropdown-list-item>
                                <ob-dropdown-list-item v-if="IsSignedDocumentForStudentExist" @click.native="$parent.onShare(content.Id, 'Student',true)">Share Signed Document</ob-dropdown-list-item>
                            </ob-dropdown>
                        </template>
                        <template v-else-if="!IsSupervisor">
                             <span class="rcss-text-warning" style="width: 290px; display:inline-block;"><i class="fa fa-warning"></i> Pending</span>
                            <!-- <ob-button type="primary" @click="showInitiateStudentInformationPopupForUpdate = false;showInitiateStudentInformationPopup = true;" style="margin-right: 10px; width: 90px;">Complete</ob-button>  -->
                        </template>
                    </template>
                    <template v-else-if="Employee.SectionStatus == 'NotInitiated'">
                        <template v-if="isHRManager">
                            <span class="rcss-text-warning" style="width: 250px; display:inline-block;"><i class="fa fa-warning"></i> Pending</span>
                            <ob-dropdown type="ellipsis">
                                <ob-dropdown-list-item @click.native="$parent.ViewOrDownloadDocument(content.Id, 'Student', false)">Preview in Form</ob-dropdown-list-item>
                                <ob-dropdown-list-item v-if="IsSignedDocumentForStudentExist" @click.native="ViewSignedDocument(SignedDocumentUrlForStudent)">View Signed Document</ob-dropdown-list-item>
                                <ob-dropdown-list-item v-if="IsSignedDocumentForStudentExist" @click.native="DownloadSignedDocument(SignedDocumentUrlForStudent)">Download Signed Document</ob-dropdown-list-item>
                                <ob-dropdown-list-item @click.native="showInitiateStudentInformationPopupForUpdate = true;showInitiateStudentInformationPopup = true;">Update Form</ob-dropdown-list-item>
                                <ob-dropdown-list-item v-if="IsSignedDocumentForStudentExist" @click.native="$parent.onShare(content.Id, 'Student',true)">Share Signed Document</ob-dropdown-list-item>
                            </ob-dropdown>
                        </template>
                        <template v-else-if="!IsSupervisor">
                            <span class="rcss-text-warning" style="width: 290px; display:inline-block;"><i class="fa fa-warning"></i> Pending</span>
                            <ob-button type="primary" @click="showInitiateStudentInformationPopupForUpdate = false;showInitiateStudentInformationPopup = true;" style="margin-right: 10px; width: 90px;">Initiate</ob-button>
                        </template>
                    </template>
                    <template v-else-if="Employee.SectionStatus == 'InComplete'">
                        <template  v-if="content.Status != 'Completed'">
                            <span v-if ="!IsSupervisor" class="rcss-text-warning" style="width: 290px; display:inline-block;"><i class="fa fa-warning"></i> Pending</span>
                            <span v-else class="rcss-text-warning" style="width: 290px; display:inline-block;"><i class="fa fa-warning"></i> Pending from Student</span>
                        </template>
                        <!-- <ob-button v-if ="!IsSupervisor" type="primary" @click="showInitiateStudentInformationPopupForUpdate = false;showInitiateStudentInformationPopup = true;IsCompleteButton = true" style="margin-right: 10px; width: 90px;">Complete</ob-button> -->
                    </template>
                    <template v-else>
                        <template v-if="studentInfoExpand && Employee.SectionStatus == 'Completed'">
                              <template  v-if="content.Status != 'Completed' && content.IsInitiated">
                                <span class="rcss-text-warning" style="width: 250px; display:inline-block;" v-if="Employee.SignedDocument == null && Employee.SignedDocumentStatus != ''"><i class="fa fa-warning"></i> {{content.SignatureType == 'Electronic' && Employee.SignedDocumentStatus == 'Pending Physical Signature' ? 'Pending Signature' : Employee.SignedDocumentStatus}}</span>
                                <span class="rcss-text-green1" style="width: 250px; display:inline-block;" v-else><i class="fa fa-check-circle"></i> {{Employee.SectionStatus}}</span>
                             </template>
                            <template v-else>
                                <span class="rcss-text-green1" style="width: 250px; display:inline-block;" v-if="Employee.SignedDocument != null"><i class="fa fa-check-circle"></i> {{Employee.SectionStatus}}</span>
                            </template>
                            <span style="width: 39px; display: inline-block;">
                                <ob-dropdown type="ellipsis" v-if ="!IsSupervisor">
                                    <ob-dropdown-list-item @click.native="$parent.ViewOrDownloadDocument(content.Id, 'Student', false)">Preview in Form</ob-dropdown-list-item>
                                    <ob-dropdown-list-item @click.native="showInitiateStudentInformationPopupForUpdate = true;showInitiateStudentInformationPopup = true;">Update</ob-dropdown-list-item>
                                    <ob-dropdown-list-item v-if="IsSignedDocumentForStudentExist" @click.native="DownloadSignedDocument(SignedDocumentUrlForStudent)">Download</ob-dropdown-list-item>
                                </ob-dropdown>
                            </span>
                        </template>
                        <template v-else>
                            <template  v-if="content.Status != 'Completed' && content.IsInitiated">
                                <span class="rcss-text-warning" style="width: 250px; display:inline-block;" v-if="Employee.SignedDocument == null && Employee.SignedDocumentStatus != ''"><i class="fa fa-warning"></i> {{content.SignatureType == 'Electronic' && Employee.SignedDocumentStatus == 'Pending Physical Signature' ? 'Pending Signature' : Employee.SignedDocumentStatus}}</span>
                                <span class="rcss-text-green1" style="width: 250px; display:inline-block;" v-else><i class="fa fa-check-circle"></i> {{Employee.SectionStatus}}</span>
                             </template>
                            <template v-else>
                                <span class="rcss-text-green1" style="width: 250px; display:inline-block;" v-if="Employee.SignedDocument != null"><i class="fa fa-check-circle"></i> {{Employee.SectionStatus}}</span>
                            </template>
                            <span style="width: 39px; display: inline-block;">
                                <ob-dropdown type="ellipsis" v-if ="!IsSupervisor">
                                    <ob-dropdown-list-item @click.native="$parent.ViewOrDownloadDocument(content.Id, 'Student', false)">Preview in Form</ob-dropdown-list-item>
                                    <ob-dropdown-list-item v-if="IsSignedDocumentForStudentExist" @click.native="ViewSignedDocument(SignedDocumentUrlForStudent)">View Signed Document</ob-dropdown-list-item>
                                    <ob-dropdown-list-item v-if="IsSignedDocumentForStudentExist" @click.native="DownloadSignedDocument(SignedDocumentUrlForStudent)">Download Signed Document</ob-dropdown-list-item>
                                    <ob-dropdown-list-item @click.native="showInitiateStudentInformationPopupForUpdate = true;showInitiateStudentInformationPopup = true;">Update Form</ob-dropdown-list-item>
                                    <ob-dropdown-list-item v-if="IsSignedDocumentForStudentExist" @click.native="$parent.onShare(content.Id, 'Student',true)">Share Signed Document</ob-dropdown-list-item>
                                </ob-dropdown>
                            </span>
                        </template>
                    </template>
                </template>
                <template slot="collapse-details">
                    <div class="col-md-12 pL0" v-if="Employee.SectionStatus == 'InComplete' && !IsSupervisor">
                        <div class="form-group">
                            <p class="complete_style">This section is incomplete. Completing it will pre-populate this data for other sections, such as Student Evaluation and Material Change.<ob-button type="link" class="complete_button" @click="showInitiateStudentInformationPopupForUpdate = false;showInitiateStudentInformationPopup = true;IsCompleteButton = true">Complete now</ob-button></p>
                        </div>
                    </div>
                    <div class="col-md-12 pL0" v-if="Employee.SectionStatus == 'PendingFromStudent' && !IsSupervisor">
                        <div class="form-group">
                            <p class="complete_style">This section is incomplete. Completing it will pre-populate this data for other sections, such as Student Evaluation and Material Change.<ob-button type="link" class="complete_button" @click="showInitiateStudentInformationPopupForUpdate = false;showInitiateStudentInformationPopup = true;">Complete now</ob-button></p>
                        </div>
                    </div>
                    <div style="transform: translateY(-20px); position: relative; z-index: 1;" v-if="(Employee.ModifiedLogs && Employee.ModifiedLogs.length > 1) || (EmployeeSharedLog && EmployeeSharedLog.length > 0)">
                        <modified-log :logs="Employee.ModifiedLogs" v-if="Employee.ModifiedLogs && Employee.ModifiedLogs.length > 1"></modified-log>
                        <span style="width: 20px; display: inline-block;" v-if="Employee.ModifiedLogs && Employee.ModifiedLogs.length > 1"></span>
                        <shared-log :logs="EmployeeSharedLog" v-if="EmployeeSharedLog && EmployeeSharedLog.length > 0"></shared-log>
                    </div>
                    <h3 class="section-title">Student Information</h3>
                    <p class="rcss-text-warning section-details-status-text" v-if="Employee.SectionStatus == 'PendingFromStudent'">
                        <template v-if="isHRManager || IsSupervisor">
                            <i class="fa fa-warning"></i> Pending from Student (Section-1&amp;2 is not submitted by the student yet.) 
                        </template>
                    </p>

                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="control-label">Student Name</label>
                                <p class="form-control-static">{{NAOrValue(Employee, 'Name')}}</p>
                            </div>
                        </div>
                        <div class="col-md-8">
                            <div class="form-group">
                                <label class="control-label">Student Email Address</label>
                                <p class="form-control-static">{{NAOrValue(Employee, 'Email')}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="control-label">Name of School Recommending STEM OPT</label>
                                <p class="form-control-static">{{NAOrValue(Employee, 'RecommendingSchoolName')}}</p>
                            </div>
                        </div>
                        <div class="col-md-8">
                            <div class="form-group">
                                <label class="control-label">Name of School Where STEM Degree Was Earned</label>
                                <p class="form-control-static">{{NAOrValue(Employee, 'DegreeEarnedSchoolName')}}</p>
                            </div>
                        </div>
                    </div>
                     <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="control-label">Designated School Official (DSO) Name</label>
                                <p class="form-control-static">{{NAOrValue(Employee, 'DSO')}}</p>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="control-label">Designated School Official (DSO) Email</label>
                                <p class="form-control-static">{{NAOrValue(Employee, 'DSOMail')}}</p>
                            </div>
                        </div>
                         <div class="col-md-4">
                            <div class="form-group">
                                <label class="control-label">Designated School Official (DSO) Phone</label>
                                <p class="form-control-static">{{NAOrValue(Employee, 'DSOPhone')}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="control-label">Designated School Official (DSO) Address</label>
                                <p class="form-control-static">{{NAOrValue(Employee, 'DSOAddress')}}</p>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="control-label">SEVIS School Code</label>
                                <p class="form-control-static">{{NAOrValue(Employee, 'RecommendingSchoolCode')}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="control-label">Student SEVIS ID No.</label>
                                <p class="form-control-static">{{NAOrValue(Employee, 'SEVISID')}}</p>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="control-label">STEM OPT Requested Period (From)</label>
                                <p class="form-control-static">{{NAOrValue(Employee, 'RequestedFrom')}}</p>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="control-label">STEM OPT Requested Period (To)</label>
                                <p class="form-control-static">{{NAOrValue(Employee, 'RequestedTo')}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="control-label">Employment Authorization Number</label>
                                <p class="form-control-static">{{NAOrValue(Employee, 'EmploymentAuthorizationNumber')}}</p>
                            </div>
                        </div>
                        <div class="col-md-8">
                            <div class="form-group">
                                <label class="control-label">Qualifying Major and Classification of Instrumental Program (CIP) Code</label>
                                <p class="form-control-static">{{NAOrValue(Employee, 'CIPCode')}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="control-label">Level/Type of Qualifying Degree</label>
                                <p class="form-control-static">{{NAOrValue(Employee, 'QualifyingDegreeType')}}</p>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="control-label">Date Awarded</label>
                                <p class="form-control-static">{{NAOrValue(Employee, 'DateAwarded')}}</p>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="control-label">Prior Degree</label>
                                <p class="form-control-static">{{NAOrValue(Employee, 'PriorDegree')}}</p>
                            </div>
                        </div>
                    </div>
                    <template v-if="IsSignedDocumentForStudentExist && content.SignatureType != 'Electronic'">

                        <div class="document-list document-list--default">
                        <div  class="document-list__header clearfix">
                            <div  class="document-list__heading">
                                <i  aria-hidden="true" class="fa fa-file-text" style="color: #4D92DF"></i>
                                 <span style="font-size: 16px;display: inline-block;width: 400px;" class="document-list__title rcss-truncate"  :title="SignedDocumentFileNameForStudent">{{SignedDocumentFileNameForStudent}}</span>

                                 <div style="margin-top: 5px;margin-left: 30px;font-weight: 500;  z-index: 1;" v-if="StudentSignedDocumentSharedLogs.length > 0 || StudentSignedDocumentModifiedLogs.length > 1">
                                    <modified-log :logs="StudentSignedDocumentModifiedLogs" v-if="StudentSignedDocumentModifiedLogs.length > 1"></modified-log>
                                    <span style="width: 20px; display: inline-block;" v-if="StudentSignedDocumentModifiedLogs.length > 1 && StudentSignedDocumentSharedLogs.length  > 0"></span>
                                     <shared-log :logs="StudentSignedDocumentSharedLogs" v-if="StudentSignedDocumentSharedLogs.length > 0"></shared-log>
                                </div>

                                 <div class="form-group" style="margin-top: 15px;padding-left: 31px;">
                                    <label class="control-label">Completed Date</label>
                                    <p class="form-control-static" style="padding: 0;">{{CompletedDateForStudent}}</p>
                                </div>

                            </div>
                            <div  class="document-list__controls">
                                 <div class="pull-right clearfix text-right">
                                 <ob-dropdown title="Actions" class="list-action-dropdown">
                                                <ob-dropdown-list-item @click.native="ViewSignedDocument(SignedDocumentUrlForStudent)">View Signed Form</ob-dropdown-list-item>
                                                <ob-dropdown-list-item v-if="!IsSupervisor" @click.native="_showUploadSignedFormPopupForUpdate('I983Student')">Update Signed Form</ob-dropdown-list-item>
                                                <ob-dropdown-list-item @click.native="DownloadSignedDocument(SignedDocumentUrlForStudent)">Download</ob-dropdown-list-item>
                                                <ob-dropdown-list-item @click.native="$parent.onShare(content.Id, 'Student' ,true)">Share Signed Form</ob-dropdown-list-item>
                                            </ob-dropdown>
                            </div>
                            </div>
                        </div>
                     </div>

                    </template>
                    <div v-else-if="content.SignatureType !='Electronic'" class="row" >
                        <div v-if="!IsSupervisor">
                          <div class="document-list document-list--default">
                            <div  class="document-list__header clearfix">
                                <div  class="document-list__heading"><i  aria-hidden="true" class="fa fa-file-text"></i> <span  class="document-list__title">Physically Signed Student Information (Section 1 & 2)</span></div><i style="margin-top: 13px;" class="fa fa-info-circle" v-tooltip="'Please upload the physically signed Student Information (Section-1 & 2).'"></i>
                                <div  class="document-list__controls">
                                     <ob-button type="primary" :disabled="Employee.SectionStatus != 'Completed'" @click="_showUploadSignedFormPopup('I983Student')"  key="uploadSignedI983Btn">Upload</ob-button>
                                </div>
                            </div>
                        </div>
                        </div>
                   </div>
                </template>
            </ob-collapse>

            <ob-collapse v-if="showCollapse('Employer')"  :type="4" :expand.sync="employerInfoExpand" :disabled="false" :theme="employerInfoTheme">
                <template slot="collapse-title">
                    EMPLOYER INFORMATION (SECTION 3 &amp; 4)
                </template>
                <template slot="collapse-title-right">
                    <template v-if="Employer.SectionStatus == 'NotInitiated'">
                        <span style="width: 290px; display: inline-block;">
                            <span class="rcss-text-warning"><i class="fa fa-warning"></i> Pending from Employer</span>
                        </span>
                    </template>
                    <template v-else-if="Employer.SectionStatus == 'InComplete'">
                        <template  v-if="content.Status != 'Completed'">
                            <span style="width: 290px; display: inline-block;">
                                <span class="rcss-text-warning"><i class="fa fa-warning"></i> Pending from Employer</span>
                            </span>
                        </template>
                    </template>
                    
                    <template v-else>
                        <template v-if="employerInfoExpand && Employer.SectionStatus == 'Completed' && content.Status != 'Completed'">
                             <template   v-if="content.Status != 'Completed' && content.IsInitiated">
                                <span class="rcss-text-warning" style="width: 250px; display:inline-block;" v-if="Employer.SignedDocument == null && Employer.SignedDocumentStatus != ''"><i class="fa fa-warning"></i> {{content.SignatureType == 'Electronic' && Employer.SignedDocumentStatus == 'Pending Physical Signature' ? 'Pending Signature' : Employer.SignedDocumentStatus}}</span>
                                <span style="width: 250px; display:inline-block;" v-else>
                                    <span class="rcss-text-green1"><i class="fa fa-check-circle"></i> {{Employer.SectionStatus}}</span>
                                </span>
                                <span style="width: 250px; display:inline-block;" v-else-if="content.Status == 'Completed' && content.IsInitiated">
                                   <span class="rcss-text-green1"><i class="fa fa-check-circle"></i> {{Employer.SectionStatus}}</span>
                                </span>
                            </template>
                            <template v-else>
                                <span style="width: 250px; display:inline-block;" v-if="Employer.SignedDocument != null && Employer.SignedDocument != ''">
                                    <span class="rcss-text-green1"><i class="fa fa-check-circle"></i> {{Employer.SectionStatus}}</span>
                                </span>
                                 <span style="width: 250px; display:inline-block;" v-else-if="content.Status == 'Completed' && content.IsInitiated">
                                    <span class="rcss-text-green1"><i class="fa fa-check-circle"></i> {{Employer.SectionStatus}}</span>
                                </span>
                            </template>
                            <span style="width: 39px; display: inline-block;">
                                <ob-dropdown type="ellipsis" v-if="IsSameEmployerHRAndSignatoryAuthority">
                                        <ob-dropdown-list-item @click.native="$parent.ViewOrDownloadDocument(content.Id, 'Employer', false)">Preview in Form</ob-dropdown-list-item>
                                        <ob-dropdown-list-item @click.native="UpdateEmployerInformation">Update</ob-dropdown-list-item>
                                        <ob-dropdown-list-item v-if="IsSignedDocumentForEmployerExist" @click.native="DownloadSignedDocument(SignedDocumentUrlForEmployer)">Download</ob-dropdown-list-item>
                                </ob-dropdown>
                            </span>
                            
                        </template>
                        <template v-else-if="content.Status != 'Completed'">
                             <template   v-if="content.Status != 'Completed' && content.IsInitiated">
                                <span class="rcss-text-warning" style="width: 250px; display:inline-block;" v-if="Employer.SignedDocument == null && Employer.SignedDocumentStatus != ''"><i class="fa fa-warning"></i> {{content.SignatureType == 'Electronic' && Employer.SignedDocumentStatus == 'Pending Physical Signature' ? 'Pending Signature' : Employer.SignedDocumentStatus}}</span>
                                <span style="width: 250px; display:inline-block;" v-else>
                                    <span class="rcss-text-green1"><i class="fa fa-check-circle"></i> {{Employer.SectionStatus}}</span>
                                </span>
                            </template>
                            <template v-else>
                                <span style="width: 250px; display:inline-block;" v-if="Employer.SignedDocument != null && Employer.SignedDocument != ''">
                                    <span class="rcss-text-green1"><i class="fa fa-check-circle"></i> {{Employer.SectionStatus}}</span>
                                </span>
                            </template>
                            <span style="width: 39px; display: inline-block;">
                                <ob-dropdown type="ellipsis" v-if="IsSameEmployerHRAndSignatoryAuthority">
                                    <ob-dropdown-list-item @click.native="$parent.ViewOrDownloadDocument(content.Id, 'Employer', false)">Preview in Form</ob-dropdown-list-item>
                                    <ob-dropdown-list-item v-if="IsSignedDocumentForEmployerExist" @click.native="ViewSignedDocument(SignedDocumentUrlForEmployer)">View Signed Document</ob-dropdown-list-item>
                                    <ob-dropdown-list-item v-if="IsSignedDocumentForEmployerExist" @click.native="DownloadSignedDocument(SignedDocumentUrlForEmployer)">Download Signed Document</ob-dropdown-list-item>
                                    <ob-dropdown-list-item @click.native="UpdateEmployerInformation">Update Form</ob-dropdown-list-item>
                                    <ob-dropdown-list-item v-if="IsSignedDocumentForEmployerExist" @click.native="$parent.onShare(content.Id, 'Employer',true)">Share Signed Document</ob-dropdown-list-item>
                                </ob-dropdown>
                            </span>
                        </template>
                    </template>
                </template>
                <template slot="collapse-details">
                     <div class="col-md-12 pL0" v-if="Employer.SectionStatus == 'InComplete' && isHRManager">
                            <div class="form-group">
                                <p class="complete_style">This employer's information is incomplete. Completing this will pre-populate the data for other actions such as material change.<ob-button type="link" class="complete_button" @click="InitiateEmployerInformation(true)" >Complete now</ob-button></p>
                            </div>
                        </div>
                        <div class="col-md-12 pL0 m0" v-else-if="Employer.SectionStatus == 'NotInitiated' && isHRManager">
                            <div class="form-group">
                                <p class="complete_style" style="font-size:12px;margin-top: -15px;">This employer's information is incomplete. Completing this will pre-populate the data for other actions such as material change.<ob-button type="link" class="complete_button"  style="font-size:12px;" @click="InitiateEmployerInformation(false)" >Complete now</ob-button></p>
                            </div>
                        </div>
                    <template v-if="Employer.SectionStatus != 'NotInitiated'">
                        <div style="transform: translateY(-20px); position: relative; z-index: 1;" v-if="(Employer.ModifiedLogs && Employer.ModifiedLogs.length > 1) || (EmployerSharedLog && EmployerSharedLog.length > 0)">
                            <modified-log :logs="Employer.ModifiedLogs" v-if="Employer.ModifiedLogs && Employer.ModifiedLogs.length > 1"></modified-log>
                            <span style="width: 20px; display: inline-block;" v-if="Employer.ModifiedLogs && Employer.ModifiedLogs.length > 1"></span>
                            <shared-log :logs="EmployerSharedLog" v-if="EmployerSharedLog && EmployerSharedLog.length > 0"></shared-log>
                        </div>
                        <h3 class="section-title">Employer Information</h3>

                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="control-label">Employer Name</label>
                                    <p class="form-control-static">{{NAOrValue(Employer, 'Name')}}</p>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="control-label">Employer Website URL</label>
                                    <p class="form-control-static">{{NAOrValue(Employer, 'Website')}}</p>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="control-label">Street Address</label>
                                    <p class="form-control-static">{{Employer.Address ? NAOrValue(Employer.Address, 'Address') : 'N/A'}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                             <div class="col-md-4">
                                <div class="form-group">
                                    <label class="control-label">Suite</label>
                                    <p class="form-control-static">{{NAOrValue(Employer, 'Suite')}}</p>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="control-label">City, State</label>
                                    <p class="form-control-static">{{Employer.Address ? NAOrValue(Employer.Address, 'Location') : 'N/A'}}</p>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="control-label">ZIP Code</label>
                                    <p class="form-control-static">{{Employer.Address ? NAOrValue(Employer.Address, 'ZipCode') : 'N/A'}}</p>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="control-label">Employer ID Number (EIN)</label>
                                    <p class="form-control-static">{{NAOrValue(Employer, 'EIN')}}</p>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="control-label">Number of Full-Time Employees in U.S.</label>
                                    <p class="form-control-static">{{NAOrValue(Employer, 'FullTimeEmployeesCount')}}</p>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="control-label">NAICS Code</label>
                                    <p class="form-control-static">{{NAOrValue(Employer, 'NAICSCode')}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="control-label">OPT Hours Per Week</label>
                                    <p class="form-control-static">{{NAOrValue(Employer, 'OPTHours')}}</p>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="control-label">Salary Amount and Frequency</label>
                                    <p class="form-control-static">$ {{Employer.Salary}}/{{_getHumanSalaryFrequency(Employer.SalaryFrequency)}}</p>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="control-label">Start Date of Employment</label>
                                    <p class="form-control-static">{{NAOrValue(Employer, 'EmploymentStartDate')}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4" v-if="Employer.OtherCompensations && Employer.OtherCompensations.length > 0">
                                <div class="form-group">
                                    <label class="control-label">Other Compensation</label>
                                    <div v-if="(Employer.OtherCompensations[0] != '' && Employer.OtherCompensations[0] != null) || (Employer.OtherCompensations[1] != '' && Employer.OtherCompensations[1] != null) || (Employer.OtherCompensations[2] != '' && Employer.OtherCompensations[2] != null) || (Employer.OtherCompensations[3] != '' && Employer.OtherCompensations[3] != null)">
                                        <p class="form-control-static" v-if="Employer.OtherCompensations[0] != '' && Employer.OtherCompensations[0] != null">1. {{Employer.OtherCompensations[0]}}</p>
                                        <p class="form-control-static" v-if="Employer.OtherCompensations[1] != '' && Employer.OtherCompensations[1] != null">2. {{Employer.OtherCompensations[1]}}</p>
                                        <p class="form-control-static" v-if="Employer.OtherCompensations[2] != '' && Employer.OtherCompensations[2] != null">3. {{Employer.OtherCompensations[2]}}</p>
                                        <p class="form-control-static" v-if="Employer.OtherCompensations[3] != '' && Employer.OtherCompensations[3] != null">4. {{Employer.OtherCompensations[3]}}</p>
                                    </div>
                                    <div v-else>
                                      <p class="form-control-static">   N/A </p>
                                    </div>

                               </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="control-label">Signatory Authority Name</label>
                                    <p class="form-control-static">{{NAOrValue(Employer.SignatoryAuthority, 'Name')}}</p>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="control-label">Signatory Authority Email</label>
                                    <p class="form-control-static">{{NAOrValue(Employer.SignatoryAuthority, 'Email')}}</p>
                                </div>
                            </div>
                        </div>


                         <template v-if="IsSignedDocumentForEmployerExist && content.SignatureType != 'Electronic'">

                             <div class="document-list document-list--default">
                                <div  class="document-list__header clearfix">
                                    <div  class="document-list__heading">
                                        <i  aria-hidden="true" class="fa fa-file-text" style="color: #4D92DF"></i>
                                        <span style="font-size: 16px;display: inline-block;width: 400px;" class="document-list__title rcss-truncate"  :title="SignedDocumentFileNameForEmployer">{{SignedDocumentFileNameForEmployer}}</span>

                                        <div style="margin-top: 5px;margin-left: 30px;font-weight: 500;  z-index: 1;"  v-if="EmployerSignedDocumentSharedLogs.length > 0 || EmployerSignedDocumentModifiedLogs.length > 1">
                                                <modified-log :logs="EmployerSignedDocumentModifiedLogs" v-if="EmployerSignedDocumentModifiedLogs.length > 1"></modified-log>
                                                <span style="width: 20px; display: inline-block;" v-if="EmployerSignedDocumentModifiedLogs.length > 1 && EmployerSignedDocumentSharedLogs.length  > 0"></span>
                                                <shared-log :logs="EmployerSignedDocumentSharedLogs" v-if="EmployerSignedDocumentSharedLogs.length > 0"></shared-log>
                                        </div>

                                        <div class="form-group" style="margin-top: 15px;padding-left: 31px;">
                                            <label class="control-label">Completed Date</label>
                                            <p class="form-control-static" style="padding: 0;">{{CompletedDateForEmployer}}</p>
                                        </div>

                                    </div>
                                    <div  class="document-list__controls">
                                        <div class="pull-right clearfix text-right">
                                        <ob-dropdown title="Actions" class="list-action-dropdown">
                                                <ob-dropdown-list-item @click.native="ViewSignedDocument(SignedDocumentUrlForEmployer)">View Signed Form</ob-dropdown-list-item>
                                                <ob-dropdown-list-item v-if="isHRManager" @click.native="_showUploadSignedFormPopupForUpdate('I983Employer')">Update Signed Form</ob-dropdown-list-item>
                                                <ob-dropdown-list-item @click.native="DownloadSignedDocument(SignedDocumentUrlForEmployer)">Download</ob-dropdown-list-item>
                                                <ob-dropdown-list-item @click.native="$parent.onShare(content.Id, 'Employer' ,true)">Share Signed Form</ob-dropdown-list-item>
                                        </ob-dropdown>
                                    </div>
                                    </div>
                                </div>
                           </div>
                    </template>
                    <div v-else class="row">
                        <div v-if="isHRManager">
                             <div class="document-list document-list--default">
                                <div  class="document-list__header clearfix">
                                    <div  class="document-list__heading"><i  aria-hidden="true" class="fa fa-file-text"></i> <span  class="document-list__title">Physically Signed Employer Information (Section 3 & 4)</span></div><i style="margin-top: 13px;" class="fa fa-info-circle" v-tooltip="'Please upload the physically signed Employer Information (Section-3 & 4).'"></i>
                                    <div  class="document-list__controls">
                                         <ob-button type="primary" :disabled="Employer.SectionStatus != 'Completed'" @click="_showUploadSignedFormPopup('I983Employer')"  key="uploadSignedI983Btn">Upload</ob-button>
                                    </div>
                                </div>
                            </div>
                     </div>
                     </div>
                    </template>
                </template>
            </ob-collapse>
            <div  v-if="(Employer.SectionStatus !='Completed' || Employer.SignedDocumentStatus == 'Pending Physical Signature' ) && content.SignatureType == 'Electronic' && IsSupervisor  && showCollapse('Employer') && IsSameEmployerHRAndSignatoryAuthority "  style="display: flex; align-items: center; justify-content: space-between; background-color:#f6d3d3 ;margin-top: -16px; margin-bottom: 15px; padding: 10px 23px;">
                <p class="complete_style" style="font-size: 12px;  margin-bottom: 0;">
                    This section is incomplete. Please complete it at your earliest convenience.
                </p>
                <div style="margin-left: 15px;">
                        <!-- <ob-button @click.native="SignatoryChange" style="background-color: white; color: blue;">Change Signature Authority</ob-button> -->
                    <ob-button  type="secondary" v-if="isInitiatedByLoggedInUser && IsSameEmployerHRAndSignatoryAuthority && AssignedTraining.SectionStatus != 'Completed'" @click.native="SignatoryChange('Employer')">Change Signatory Authority</ob-button>
                    <ob-button type="primary"  @click="InitiateEmployerInformation(true)"  >Start Filling</ob-button>
                </div>            
             </div>
           <ob-collapse v-if="showCollapse('Training')" :type="4" :expand.sync="trainingPlanExpand" :disabled="false" :theme="trainingPlanTheme">
            <template slot="collapse-title">
                TRAINING PLAN FOR STEM OPT STUDENTS
            </template>
            <template slot="collapse-title-right">
                <template v-if="AssignedTraining.SectionStatus == 'PendingFromStudent'">
                    <template v-if="isHRManager || IsSupervisor">
                        <span class="rcss-text-warning" style="width: 250px; display:inline-block;"><i class="fa fa-warning"></i> Pending from Student</span>
                        <ob-dropdown type="ellipsis" v-if="AssignedTraining.SignedDocumentStatus != 'Pending Physical Signature' || content.SignatureType == 2">
                           <ob-dropdown-list-item @click.native="$parent.ViewOrDownloadDocument(content.Id, 'AssignedTraining', false)">Preview in Form</ob-dropdown-list-item>
                                <ob-dropdown-list-item v-if="IsSignedDocumentForAssignedTrainingExist" @click.native="ViewSignedDocument(SignedDocumentUrlForAssignedTraining)">View Signed Document</ob-dropdown-list-item>
                                <ob-dropdown-list-item v-if="IsSignedDocumentForAssignedTrainingExist" @click.native="DownloadSignedDocument(SignedDocumentUrlForAssignedTraining)">Download Signed Document</ob-dropdown-list-item>
                                <ob-dropdown-list-item @click.native="showUpdateTrainingPlanPopupForVerify = false;showUpdateTrainingPlanPopup = true;">Update Form</ob-dropdown-list-item>
                                <ob-dropdown-list-item v-if="IsSignedDocumentForAssignedTrainingExist" @click.native="$parent.onShare(content.Id, 'AssignedTraining',true)">Share Signed Document</ob-dropdown-list-item>
                        </ob-dropdown>
                    </template>
                    <template v-else>
                        <span class="rcss-text-warning" style="width: 290px; display:inline-block;"><i class="fa fa-warning"></i> Pending</span>
                    </template>
                </template>
                <template v-else-if="AssignedTraining.SectionStatus == 'NotInitiated'">
                    <template v-if="isHRManager || IsSupervisor">
                        <span class="rcss-text-warning" style="width: 250px; display:inline-block;"><i class="fa fa-warning"></i> Pending</span>
                        <ob-dropdown type="ellipsis" v-if="AssignedTraining.SignedDocumentStatus != 'Pending Physical Signature' || content.SignatureType == 2">
                            <ob-dropdown-list-item @click.native="$parent.ViewOrDownloadDocument(content.Id, 'AssignedTraining', false)">Preview in Form</ob-dropdown-list-item>
                                <ob-dropdown-list-item v-if="IsSignedDocumentForAssignedTrainingExist" @click.native="ViewSignedDocument(SignedDocumentUrlForAssignedTraining)">View Signed Document</ob-dropdown-list-item>
                                <ob-dropdown-list-item v-if="IsSignedDocumentForAssignedTrainingExist" @click.native="DownloadSignedDocument(SignedDocumentUrlForAssignedTraining)">Download Signed Document</ob-dropdown-list-item>
                                <ob-dropdown-list-item @click.native="showUpdateTrainingPlanPopupForVerify = false;showUpdateTrainingPlanPopup = true;">Update Form</ob-dropdown-list-item>
                                <ob-dropdown-list-item v-if="IsSignedDocumentForAssignedTrainingExist" @click.native="$parent.onShare(content.Id, 'AssignedTraining',true)">Share Signed Document</ob-dropdown-list-item>
                        </ob-dropdown>
                    </template>
                    <template v-else>
                        <span class="rcss-text-warning" style="width: 290px; display:inline-block;"><i class="fa fa-warning"></i> Pending</span>
                        <!-- <ob-button type="primary" @click="showUpdateTrainingPlanPopupForVerify = true; showUpdateTrainingPlanPopup = true;" style="margin-right: 10px; width: 90px;">Complete</ob-button> -->
                    </template>
                </template>
                <template v-else-if="AssignedTraining.SectionStatus == 'InComplete'  || (AssignedTraining.Training == null || AssignedTraining.Training.Title == null)">
                    <template v-if="content.Status != 'Completed' && content.IsInitiated">
                        <span class="rcss-text-warning" style="width: 290px; display:inline-block;"><i class="fa fa-warning"></i> Pending</span>
                    </template>
                </template>
                <template v-else>
                    <template v-if="trainingPlanExpand && AssignedTraining.SectionStatus == 'Completed'">
                        <template   v-if="content.Status != 'Completed' && content.IsInitiated">
                            <span class="rcss-text-warning" style="width: 250px; display:inline-block;" v-if="AssignedTraining.SignedDocument == null && AssignedTraining.SignedDocumentStatus != ''"><i class="fa fa-warning"></i> {{content.SignatureType == 'Electronic' && AssignedTraining.SignedDocumentStatus == 'Pending Physical Signature' ? 'Pending Signature from Employer' : AssignedTraining.SignedDocumentStatus}}</span>
                            <span class="rcss-text-green1" style="width: 250px; display:inline-block;" v-else><i class="fa fa-check-circle"></i> {{AssignedTraining.SectionStatus}}</span>
                        </template>
                        <template v-else>
                            <span class="rcss-text-green1" style="width: 250px; display:inline-block;" v-if="AssignedTraining.SignedDocument != null && AssignedTraining.SignedDocument != ''"><i class="fa fa-check-circle"></i> {{AssignedTraining.SectionStatus}}</span>
                        </template>
                        <ob-dropdown type="ellipsis">
                            <ob-dropdown-list-item @click.native="$parent.ViewOrDownloadDocument(content.Id, 'AssignedTraining', false)">Preview in Form</ob-dropdown-list-item>
                            <ob-dropdown-list-item @click.native="showUpdateTrainingPlanPopupForVerify = false;showUpdateTrainingPlanPopup = true;">Update</ob-dropdown-list-item>
                            <ob-dropdown-list-item v-if="IsSignedDocumentForAssignedTrainingExist" @click.native="DownloadSignedDocument(SignedDocumentUrlForAssignedTraining)">Download</ob-dropdown-list-item>
                        </ob-dropdown>
                    </template>
                    <template v-else>
                        <template   v-if="content.Status != 'Completed' && content.IsInitiated">
                            <span class="rcss-text-warning" style="width: 250px; display:inline-block;" v-if="AssignedTraining.SignedDocument == null && AssignedTraining.SignedDocumentStatus != ''"><i class="fa fa-warning"></i> {{content.SignatureType == 'Electronic' && AssignedTraining.SignedDocumentStatus == 'Pending Physical Signature' ? 'Pending Signature from Employer' : AssignedTraining.SignedDocumentStatus}}</span>
                            <span class="rcss-text-green1" style="width: 250px; display:inline-block;" v-else><i class="fa fa-check-circle"></i> {{AssignedTraining.SectionStatus}}</span>
                        </template>
                        <template v-else>
                            <span class="rcss-text-green1" style="width: 250px; display:inline-block;" v-if="AssignedTraining.SignedDocument != null && AssignedTraining.SignedDocument != ''"><i class="fa fa-check-circle"></i> {{AssignedTraining.SectionStatus}}</span>
                        </template>
                        <ob-dropdown type="ellipsis" v-if="AssignedTraining.SignedDocumentStatus != 'Pending Physical Signature' || content.SignatureType == 2">
                            <ob-dropdown-list-item @click.native="$parent.ViewOrDownloadDocument(content.Id, 'AssignedTraining', false)">Preview in Form</ob-dropdown-list-item>
                            <ob-dropdown-list-item v-if="IsSignedDocumentForAssignedTrainingExist" @click.native="ViewSignedDocument(SignedDocumentUrlForAssignedTraining)">View Signed Document</ob-dropdown-list-item>
                            <ob-dropdown-list-item v-if="IsSignedDocumentForAssignedTrainingExist" @click.native="DownloadSignedDocument(SignedDocumentUrlForAssignedTraining)">Download Signed Document</ob-dropdown-list-item>
                            <ob-dropdown-list-item @click.native="showUpdateTrainingPlanPopupForVerify = false;showUpdateTrainingPlanPopup = true;">Update Form</ob-dropdown-list-item>
                            <ob-dropdown-list-item v-if="IsSignedDocumentForAssignedTrainingExist" @click.native="$parent.onShare(content.Id, 'AssignedTraining',true)">Share Signed Document</ob-dropdown-list-item>
                        </ob-dropdown>
                    </template>
                </template>
            </template>
            <template slot="collapse-details">
                 <div class="col-md-12 pL0" v-if="AssignedTraining.SectionStatus == 'PendingFromStudent' && !IsSupervisor">
                    <div class="form-group">
                        <p class="complete_style">This section is incomplete. Completing it will pre-populate this data for other sections, such as Student Evaluation and Material Change.<ob-button type="link" class="complete_button"  @click="showUpdateTrainingPlanPopupForVerify = true; showUpdateTrainingPlanPopup = true;" >{{AssignedTraining.Training.Title == '' ? 'Complete' : 'Verify'}}</ob-button></p>
                    </div>
                </div>
                 <div class="col-md-12 pL0 m0" v-else-if="AssignedTraining.SectionStatus == 'NotInitiated' && !IsSupervisor">
                    <div class="form-group">
                        <p class="complete_style" v-if="content.SignatureType != 'Electronic'">This section is incomplete. Completing it will pre-populate this data for other sections, such as Student Evaluation and Material Change.<ob-button type="link" class="complete_button" @click="showUpdateTrainingPlanPopupForVerify = true; showUpdateTrainingPlanPopup = true;">Complete now</ob-button></p>
                    </div>
                </div>
                <div class="col-md-12 pL0 m0" v-else-if="AssignedTraining.SectionStatus == 'InComplete'">
                    <div class="form-group">
                        <p class="complete_style" v-if="!IsSupervisor">This information is incomplete. Completing this will pre-populate the data for other actions such as student evaluation & material change.<ob-button type="link" class="complete_button" @click="showUpdateTrainingPlanPopupForVerify = true; showUpdateTrainingPlanPopup = true;IsCompleteButton = true">Complete now</ob-button></p>
                    </div>
                </div>
                <div class="col-md-12 pL0 m0" v-else-if="AssignedTraining.SectionStatus == 'Initiated'">
                    <div class="form-group">
                        <p class="complete_style" v-if="!IsSupervisor">This information is incomplete. Completing this will pre-populate the data for other actions such as student evaluation & material change.<ob-button type="link" class="complete_button" @click="showUpdateTrainingPlanPopupForVerify = true; showUpdateTrainingPlanPopup = true;IsCompleteButton = true">Complete now</ob-button></p>
                    </div>
                </div>



                <div style="transform: translateY(-20px); position: relative; z-index: 1;" v-if="(AssignedTraining.ModifiedLogs && AssignedTraining.ModifiedLogs.length > 1) || (TrainingPlanSharedLog && TrainingPlanSharedLog.length > 0)">
                    <modified-log :logs="AssignedTraining.ModifiedLogs" v-if="AssignedTraining.ModifiedLogs && AssignedTraining.ModifiedLogs.length > 1"></modified-log>
                    <span style="width: 20px; display: inline-block;" v-if="AssignedTraining.ModifiedLogs && AssignedTraining.ModifiedLogs.length > 1"></span>
                    <shared-log :logs="TrainingPlanSharedLog" v-if="TrainingPlanSharedLog && TrainingPlanSharedLog.length > 0"></shared-log>
                </div>
                <p class="rcss-text-warning section-details-status-text" v-if="(isHRManager || IsSupervisor )&& AssignedTraining.SectionStatus == 'PendingFromStudent'">
                    <i class="fa fa-warning"></i> Pending from Student (Section-5 is not submitted by the student yet.)
                </p>
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label class="control-label">Site Name</label>
                            <p class="form-control-static">{{NAOrValue(content.AssignedTraining, 'SiteName')}}</p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label class="control-label">Site Address (Street, City, State, ZIP)</label>
                            <p class="form-control-static">{{NAOrValue(content.AssignedTraining, 'SiteAddress')}}</p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label class="control-label">Name of Official</label>
                            <p class="form-control-static">{{NAOrValue(AssignedTraining.SignatoryAuthority, 'Name')}}</p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label class="control-label">Official's Title</label>
                            <p class="form-control-static">{{NAOrValue(AssignedTraining.SignatoryAuthority, 'Title')}}</p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label class="control-label">Official's Email</label>
                            <p class="form-control-static">{{NAOrValue(AssignedTraining.SignatoryAuthority, 'Email')}}</p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label class="control-label">Official's Phone Number</label>
                            <p class="form-control-static">{{NAOrValue(AssignedTraining.SignatoryAuthority, 'Phone')}}</p>
                        </div>
                    </div>
                </div>
                 <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="control-label">Signatory Authority Name</label>
                                    <p class="form-control-static">{{NAOrValue(AssignedTraining.SignatoryAuthority, 'Name')}}</p>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="control-label">Signatory Authority Email</label>
                                    <p class="form-control-static">{{NAOrValue(AssignedTraining.SignatoryAuthority, 'Email')}}</p>
                                </div>
                            </div>
                    </div>

                <div class="row">
                    <div class="col-md-12 training_plan_border">
                        <div class="form-group">
                            <label class="control-label">Training Plan Title</label>
                            <p class="form-control-static">{{NAOrValue(AssignedTraining.Training, 'Title')}}</p>
                        </div>
                    </div>
                    <div class="col-md-12 training_plan_border">
                        <div class="form-group">
                            <label class="control-label">Student Role: Describe the student's role with the employer and how that role is directly related to enhancing the student's knowledge obtained through his or her qualifying STEM degree.</label>
                            <p class="form-control-static">{{NAOrValue(AssignedTraining.Training, 'StudentRole')}}</p>
                        </div>
                    </div>
                    <div class="col-md-12 training_plan_border">
                        <div class="form-group">
                            <label class="control-label">Goals and Objectives: Describe how the assignment(s) with the employer will help the student achieve his or her specific objectives for work-based learning related to his or her STEM degree. The description must both specify the student's goals regarding specific knowledge, skills, or techniques as well as the means by which they will be achieved.</label>
                            <p class="form-control-static">{{NAOrValue(AssignedTraining.Training, 'Objectives')}}</p>
                        </div>
                    </div>
                    <div class="col-md-12 training_plan_border">
                        <div class="form-group">
                            <label class="control-label">Employer Oversight: Explain how the employer provides oversight and supervision of individuals filling positions such as that being filled by the named F-1 student. If the employer has a training program or related policy in place that controls such oversight and supervision, please describe.</label>
                            <p class="form-control-static">{{NAOrValue(AssignedTraining.Training, 'EmployerOverSight')}}</p>
                        </div>
                    </div>
                    <div class="col-md-12 training_plan_border">
                        <div class="form-group">
                            <label class="control-label">Measures and Assessments· Explain how the employer measures and confirms whether individuals filling positions such as that being filled by the named F-1 student are acquiring new knowledge and skills. If the employer has a training program or related policy in place that controls such measures and assessments, please describe.</label>
                            <p class="form-control-static">{{NAOrValue(AssignedTraining.Training, 'Assessments')}}</p>
                        </div>
                    </div>
                    <div class="col-md-12 training_plan_border">
                        <div class="form-group">
                            <label class="control-label">Additional Remarks</label>
                            <p class="form-control-static">{{NAOrValue(AssignedTraining.Training, 'AdditionalRemarks')}}</p>
                        </div>
                    </div>
                </div>
                <div class="row" style="border-bottom: 1px dashed #c2c2c2;;margin-bottom: 10px;padding-left:0;padding-bottom: 10px;">
                        <div class="col-md-12">
                            <div style="display: inline-block;">
                                <h3 class="section">Attachments and links</h3>
                            </div>
                            <div style="display: inline-block;float: right;">
                                <span>
                                   <a @click="showAddAttachmentsPopup = true" class="add-doc"> + Add new attachment/link </a>
                               </span>
                            </div>
                        </div>
                        <div class="col-md-12" v-if="AssignedTraining.Training.SupportingDocument && AssignedTraining.Training.SupportingDocument.length > 0 || AssignedTraining.Training.SupportingLink && AssignedTraining.Training.SupportingLink.length > 0">
                          <div class="form-group">
                            <template v-if="AssignedTraining.Training.SupportingDocument && AssignedTraining.Training.SupportingDocument.length > 0">
                                <template v-for="(doc,index) in AssignedTraining.Training.SupportingDocument">
                                    <div class="doc-links-view" v-if="doc.DocUrl != '' && doc.DocUrl != null">
                                        <!-- <i class="fa fa-paperclip"></i> -->

                                        <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/attachment-gray-icon.svg`" />
                                        <a :href="doc.DocUrl" target="_blank" style="color: rgb(103, 106, 108);">
                                                            {{doc.DocUrl | I9URL2FileName}}
                                                        </a>
                                        <span style="margin-top: -25px; padding-top: 2px;padding-bottom: 6px;margin-left: 3px;">
                                                            <span class="cross-mark"  @click="confirmDeleteDocuments(doc.Id,true,index)" style="font-size: 10px; padding: 2px 5px;" >&#10006;</span>
                                        </span>
                                    </div>
                                </template>
                            </template>

                            <template v-if="AssignedTraining.Training.SupportingLink && AssignedTraining.Training.SupportingLink.length > 0">
                                <template v-for="(link,Lindex) in AssignedTraining.Training.SupportingLink">
                                    <div class="doc-links-view" v-if="link != '' && link != null">
                                        <!-- <i class="fa fa-paperclip"></i> -->
                                        <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/link-gray-icon.svg`" />
                                        <a :href="linkUrl(link)" target="_blank" style="color: rgb(103, 106, 108);">
                                                            {{link}}
                                       </a>
                                        <span style="margin-top: -25px; padding-top: 2px;padding-bottom: 6px;margin-left: 3px;">
                                                            <span class="cross-mark"  @click="confirmDeleteDocuments(link,false,Lindex)" style="font-size: 10px; padding: 2px 5px;" >&#10006;</span>
                                        </span>
                                    </div>
                                </template>
                            </template>
                            </div>
                        </div>
                        <div class="form-group" v-else>
                            <span class="remove-doc" style="margin-left: 12px;"> No attachments and links are added  </span>
                        </div>
                </div>

                <template v-if="IsSignedDocumentForAssignedTrainingExist && content.SignatureType != 'Electronic'">

                     <div class="document-list document-list--default">
                        <div  class="document-list__header clearfix">
                            <div  class="document-list__heading">
                                <i  aria-hidden="true" class="fa fa-file-text" style="color: #4D92DF"></i>
                                 <span style="font-size: 16px;display: inline-block;width: 400px;" class="document-list__title rcss-truncate"  :title="SignedDocumentFileNameForAssignedTraining">{{SignedDocumentFileNameForAssignedTraining}}</span>

                                 <div style="margin-top: 5px;margin-left: 30px;font-weight: 500; z-index: 1;" v-if="AssignedTrainingSignedDocumentSharedLogs.length > 0 || AssignedTrainingSignedDocumentModifiedLogs.length > 1">
                                    <modified-log :logs="AssignedTrainingSignedDocumentModifiedLogs" v-if="AssignedTrainingSignedDocumentModifiedLogs.length > 1"></modified-log>
                                    <span style="width: 20px; display: inline-block;" v-if="AssignedTrainingSignedDocumentModifiedLogs.length > 1 && AssignedTrainingSignedDocumentSharedLogs.length  > 0"></span>
                                    <shared-log :logs="AssignedTrainingSignedDocumentSharedLogs" v-if="AssignedTrainingSignedDocumentSharedLogs.length > 0"></shared-log>
                                </div>

                                 <div class="form-group" style="margin-top: 15px;padding-left: 31px;">
                                    <label class="control-label">Completed Date</label>
                                    <p class="form-control-static" style="padding: 0;">{{CompletedDateForAssignedTraining}}</p>
                                </div>

                            </div>
                            <div  class="document-list__controls">
                                 <div class="pull-right clearfix text-right">
                                <ob-dropdown title="Actions" class="list-action-dropdown">
                                    <ob-dropdown-list-item @click.native="ViewSignedDocument(SignedDocumentUrlForAssignedTraining)">View Signed Form</ob-dropdown-list-item>
                                    <ob-dropdown-list-item @click.native="_showUploadSignedFormPopupForUpdate('I983AssignedTraining')">Update Signed Form</ob-dropdown-list-item>
                                    <ob-dropdown-list-item @click.native="DownloadSignedDocument(SignedDocumentUrlForAssignedTraining)">Download</ob-dropdown-list-item>
                                    <ob-dropdown-list-item @click.native="$parent.onShare(content.Id, 'AssignedTraining' ,true)">Share Signed Form</ob-dropdown-list-item>
                                </ob-dropdown>
                            </div>
                            </div>
                        </div>
                     </div>
                </template>
                <div v-else class="row" style="margin-top: 10px;">
                    <div class="document-list document-list--default" v-if="content.SignatureType !='Electronic'">
                        <div  class="document-list__header clearfix">
                            <div  class="document-list__heading"><i  aria-hidden="true" class="fa fa-file-text"></i> <span  class="document-list__title">Physcially Signed Training plan (section 5 & 6)</span></div><i style="margin-top: 13px;" class="fa fa-info-circle" v-tooltip="'Please upload the physically signed Training Plan (section-5 & 6).'"></i>
                            <div  class="document-list__controls">
                                  <ob-button type="primary" :disabled="AssignedTraining.SectionStatus != 'Completed'" @click="_showUploadSignedFormPopup('I983AssignedTraining')" key="uploadSignedI983Btn">Upload</ob-button>
                            </div>
                        </div>
                     </div>
                </div>

            </template>
         </ob-collapse>
             <div v-if="(AssignedTraining.SectionStatus !='Completed' || AssignedTraining.SignedDocumentStatus == 'Pending Physical Signature') && content.SignatureType == 'Electronic' && showCollapse('Employer')  && IsSameAssignedTrainingHRAndSignatoryAuthority && IsSupervisor"  style="display: flex; align-items: center; justify-content: space-between; background-color:#f6d3d3 ;margin-top: -16px; margin-bottom: 15px; padding: 10px 23px;">
                <p  v-if="AssignedTraining.SectionStatus != 'PendingFromStudent'" class="complete_style" style="font-size: 12px;  margin-bottom: 0;">
                    The employee has completed or reviewed the training plan,please review and sign it at your earliest convinence
                </p>
                <p  v-if="AssignedTraining.SectionStatus == 'PendingFromStudent'" class="complete_style" style="font-size: 12px;  margin-bottom: 0;">
                    Once the Student completes the section,you will need to review and sign it.
                </p>
                <div  v-if="AssignedTraining.SectionStatus != 'PendingFromStudent'" style="display: flex; gap: 10px; margin-left: 15px;">
                    <ob-button style="margin-right: 10px;" type="secondary" v-if="isInitiatedByLoggedInUser" @click.native="SignatoryChange('AssignedTraining')">Change Signature Authority</ob-button>
                    <ob-button type="primary" @click="UpdateTrainingPlanPopup" v-if="AssignedTraining.SectionStatus !='PendingFromStudent' && IsSameAssignedTrainingHRAndSignatoryAuthority"> Start Reviewing  </ob-button>
                
                </div>
                
                            
             </div>
        </div>
    </div>

    <initiate-student-information-popup ref="student" :openModal.sync="showInitiateStudentInformationPopup" :isupdate="showInitiateStudentInformationPopupForUpdate" :content.sync="clonedContent"></initiate-student-information-popup>
    <initiate-employer-popup ref="employer" :show.sync="showInitiateEmployerPopup" :isupdate="showInitiateEmployerPopupForUpdate" :content.sync="clonedContent"></initiate-employer-popup>
    <update-training-plan-popup ref="assignedTraining" :openModal.sync="showUpdateTrainingPlanPopup" :content.sync="clonedContent" :isverify="showUpdateTrainingPlanPopupForVerify" :IsReviewTrainingPlan="IsReviewTrainingPlan"></update-training-plan-popup>

    <initiate-material-change-popup :openModal.sync="showInitiateMaterialChangePopup" :isupdate="showInitiateMaterialChangePopupForUpdate" :updatecontent.sync="MaterialChangeObjForUpdate" :content.sync="clonedContent"></initiate-material-change-popup>
    <initiate-student-evaluation ref="evaluation" :openModal.sync="showInitiateStudentEvaluationPopup" :isupdate="showInitiateStudentEvaluationPopupForUpdate" :previousData.sync="EvaluationObjForUpdate" :triggerupdateapi="true" :isSupervisor="IsSupervisor"></initiate-student-evaluation>

     <preview-pdf :previewSectionType="previewSectionType" :previewURL="previewURL" :openModal.sync="showPreviewPopup"></preview-pdf>
     <copyMail :openModal.sync ="isCopySectionPopupVisible" :copymailsectionType="copymailsectionType" :content.sync="content"></copyMail>
     <changeSignAuth :openModal.sync ="isChangeSignAuth"  :ChangeSAType="ChangeSAType" :content.sync="content" ></changeSignAuth>
    <ob-modal2 v-if="showUploadSignedFormPopup" :show.sync="showUploadSignedFormPopup" :backdrop="false">
        <template slot="modal-title">
            {{showUploadSignedFormPopupForUpdate ? 'Update' : 'Upload' }} Physically Signed {{TitleForUpload}}
        </template>
        <template slot="modal-body">
            <h3 class="section-title">Note : {{tooltipContentForSignedDoc}} </h3>
            <transition name="slide-fade">
                <ob-dynamic-form-fields-ess ref="dynamicformfield" v-if="showUploadSignedFormPopup" :validate="doValidation" :isValid.sync="isFormValid" :field-list="documentsTableHeader" :documentGroup="documentGroup" :documentType="documentType" :field-values.sync="fieldValues" :isUploading.sync="isUploading" :documentList="documentList"></ob-dynamic-form-fields-ess>
            </transition>
        </template>
        <template slot="modal-footer">
            <ob-button :disabled="isUploading" type="secondary" @click="showUploadSignedFormPopup=false ;">Cancel</ob-button>
            <ob-button :disabled="isUploading" @click="uploadSignedForm">{{showUploadSignedFormPopupForUpdate ? 'Update' : 'Upload' }}</ob-button>
        </template>
    </ob-modal2>
      <!-- add new attachment -->

    <ob-modal2 v-if="showAddAttachmentsPopup" :show.sync="showAddAttachmentsPopup" :backdrop="false">
                <template slot="modal-title">
                    Add new attachment/link
                </template>
                <template slot="modal-body">
                    <!-- Add Document -->
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <div v-for="(doc,index) in SupportingDocuments" :key="index">
                                    <label> Upload Supporting Document ( Attachment ) </label>
                                    <a @click="removeDocument(index)" class="remove-doc" style="float: right" v-if="index != 0">-Remove document</a>
                                   <p style="font-style: italic; margin-bottom: 10px; font-size: 12px;">We accept either pdf, .doc, .docx, zip, images upto 100MB.</p>
                                    <transition name="slide-fade">
                                        <ob-upload-new  ref="child1" :validation="documantValidation" :end-point="EndPoint" @file-complete="uploadComplete(index, ...arguments)" @remove-file="SupportingDocuments[index].DocUrl = ''" :IsFileExists="SupportingDocuments[index].DocUrl | I9URL2FileName" :type="2" :isUploading.sync="isUploading">
                                            <template slot="file-text">
                                                <i class="fa fa-cloud-upload" aria-hidden="true"></i> Drag and Drop OR Choose The File
                                            </template>
                                        </ob-upload-new>
                                    </transition>
                                     <span class="ob-vuelidate_error-msg" style="padding-left: 5px"
                                            v-if="SupportingDocuments[index].isErrorMessageDisabled && $refs.child1[index].Errors.length==0" >{{SupportingDocuments[index].errorMessageFrmResponse}} </span>
                                </div>
                                <div class="row m0">
                                    <a @click="addDocument(SupportingDocuments)" class="add-doc">  + Add new document</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                    <label style="margin-top: 2%;">Supporting Links</label>
                                   <ob-select2 :inModal="true" v-model.trim="SupportingLinks" :options="SupportingLinkOptions" :multiple="true"></ob-select2>
                            </div>
                        </div>
                    </div>
                </template>
                <template slot="modal-footer">
                    <ob-button :disabled="isUploading" type="secondary" @click="cancelAttachmentDoc()">Cancel</ob-button>
                    <ob-button :disabled="isUploading" type="primary"  @click="addNewAttachment()">Add</ob-button>
                </template>
       </ob-modal2>
       <ob-modal2 :show.sync="openAddUnTrustedSitesPopUp" :type="1">
        <div class="" style="padding:30px 15px;text-align:center">
          <img style="width:45px;" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/info_red_icon.svg`" />
          <p class="warning-content">OnBlick Trusted Sites</p>
          <h4 style="LINE-HEIGHT: 20px;display: inline;"> The domain(s) mentioned have not been included in our trusted sites. <br/>
                 Click on the "Add" button to add them to our list of trusted domains.
          </h4>
        </div>
        <div class="modal-soc--footer" style="padding: 0px 20px 20px 20px;text-align:center;">
          <ob-button type="secondary"  @click="cancelAddPopup">Cancel</ob-button>
          <ob-button @click="AddTrustedSitesLinkPopup">Add</ob-button>
        </div>
      </ob-modal2>



</div>
</template>
<script>
import c from 'Vue/Core/constants.js'

import ListOfDocuments from './RequestModel.js'

import utils from "Vue/Core/utils.js";

import ModifiedLog from './ModifiedLog.vue';
import SharedLog from './SharedLog.vue';

import InitiateStudentInformation from './InitiateStudentInformation'
import InitiateEmployerInfo from './InitiateEmployerInfo.vue'
// import UpdateTrainingPlanPopup from './UpdateTrainingPlanPopup'

import InitiateMaterialChangePopup from './InitiateMaterialChangePopup.vue';
import InitiateStudentEvalution from './InitiateStudentEvalution.vue';

import PreviewPdf from './PreviewPdf.vue';
import CopyMail from './CopyMail.vue';
import ChangeSignAuth from './ChangeSignAuth.vue'
import UpdateTrainingPlanPopup from './UpdateTrainingPlanPopup.vue';
export default {
    props: ["content"],
    data() {
        return {
            IsReviewTrainingPlan:false,
            userDetails:'',
            ChangeSAType:'',
            copymailsectionType: '',
            isCopySectionPopupVisible: false,
            isChangeSignAuth: false,
            openAddUnTrustedSitesPopUp:false,
            showInitiateEmployerPopup: false,
            showInitiateEmployerPopupForUpdate: false,

            showInitiateStudentInformationPopup: false,
            showInitiateStudentInformationPopupForUpdate: false,

            showUpdateTrainingPlanPopup: false,
            showUpdateTrainingPlanPopupForVerify: false,

            showInitiateMaterialChangePopup: false,
            showInitiateMaterialChangePopupForUpdate: false,

            showInitiateStudentEvaluationPopup: false,
            showInitiateStudentEvaluationPopupForUpdate: false,

            showPreviewPopup:false,
            previewURL:'',
            previewSectionType:'',


            studentInfoExpand: false,
            employerInfoExpand: false,
            trainingPlanExpand: false,
            evaluationExpand: false,

            // Signed Form
            showUploadSignedFormPopup: false,
            showUploadSignedFormPopupForUpdate: false,
            doValidation: false,
            isFormValid: false,
            isUploading: false,
            documentGroup: "FormI983",

           selectedSectionForDocUpload:'',

            showAddAttachmentsPopup:false,
             SupportingDocuments: [{
                        DocUrl:'',
                        errorMessageFrmResponse:'',
                        isErrorMessageDisabled: false,
            }],
             SupportingLinks: '',

               SupportingLinkOptions: {
                     tags: true,
                     tokenSeparators: [','] ,
                    placeholder: {
                        id: '-1', // the value of the option
                        text: 'Please enter'
                    },
                    data: []
                },

            //upload doc
            DocUrl:'',
            EndPoint: `${c.APIBASEURL}/File/FileUpload?isPrivate=false`,
            isUploading: false,
            documantValidation: {
            Rules: {
                    Type: ["pdf", "zip", "doc", "docx", "png", "gif", "jpg", "jpeg"],
                    Size: 110000000, // In Bytes
                    multiplefiles: false
                    },
            Messages: {
                        Type: "Please upload valid file formats",
                        Size: `Please upload a file which is less than 100MB`,
                        }
                },


         }
    },
    components: {
        'initiate-student-information-popup' : InitiateStudentInformation,
        'initiate-employer-popup' : InitiateEmployerInfo,
        'update-training-plan-popup' : UpdateTrainingPlanPopup,
        'modified-log' : ModifiedLog,
        'shared-log' : SharedLog,
        'initiate-material-change-popup': InitiateMaterialChangePopup,
        'initiate-student-evaluation': InitiateStudentEvalution,
        'preview-pdf':PreviewPdf,
        'copyMail':CopyMail ,
        'changeSignAuth':ChangeSignAuth,
    },
    computed: {
        isInitiatedByLoggedInUser(){
            if(this.loggedInUserObj.name == this.InitiatedBy) {
            return true 
        }else{
            return false
        }
        },
        IsSameEmployerHRAndSignatoryAuthority() {
                if( this.userDetails.email ==  this.content.Employer.SignatoryAuthority.Email){
                    return true
                }else {
                    return false
                }
            },
            IsSameEvaluationHRAndSignatoryAuthority() {
                if( this.userDetails.email ==  this.content.Evaluation.SignatoryAuthority.Email){
                    return true
                }else {
                    return false
                }
            },
            IsSameAssignedTrainingHRAndSignatoryAuthority() {
                if( this.userDetails.email ==  this.content.AssignedTraining.SignatoryAuthority.Email){
                    return true
                }else {
                    return false
                }
            },
        completeSharedLog()
        {
            if(this.content.IsInitiateOnlySectionType)
            {
                if(this.content.Type == 'Evaluation' && this.content.Evaluation.SectionStatus == 'Completed')
                {
                     return this.EvaluationSignedDocumentSharedLogs;
                }
                else if(this.content.Type == 'MaterialChange' && this.content.Employer.SectionStatus == 'Completed')
                {

                    return this.EmployerSignedDocumentSharedLogs;
                }
                return []
            }
            else
            {

                return this.content.SharedLog.filter(v=> {
                                                      return v.CreatedBy.Email == this.loggedInUserEmail});
            }
        },
        EmployeeSharedLog()
        {
           return this.Employee.SharedLogs.filter(v=> {
                                                      return v.CreatedBy.Email == this.loggedInUserEmail});
        },
        EmployerSharedLog()
        {
           return this.Employer.SharedLogs.filter(v=> {
                                                      return v.CreatedBy.Email == this.loggedInUserEmail});
        },
        TrainingPlanSharedLog()
        {
           return this.AssignedTraining.SharedLogs.filter(v=> {
                                                      return v.CreatedBy.Email == this.loggedInUserEmail});
        },
        EvalutionSharedLog()
        {
           return this.Evaluation.SharedLogs.filter(v=> {
                                                      return v.CreatedBy.Email == this.loggedInUserEmail});
        },

        showVerifyButton()
        {
            if(!this.IsEvaluationVerifiedBySupervisor && !this.IsSignedDocumentForEvaluationExist && (this.content.Status != "StudentEvaluationPending"))
            {
                return true
            }
            return false
        },
        
  tooltipContentForSignedDoc()
        {
            if(this.selectedSectionForDocUpload == 'I983')
            {
                 return 'Please upload the complete Form I-983 which is physically signed by the student and the employer.'
            }
            else if(this.selectedSectionForDocUpload == 'I983Evaluation')
            {
                  return 'Please upload the physically signed Student Evaluation.'
            }
            else if(this.selectedSectionForDocUpload == 'I983Student')
            {
                 return 'Please upload the physically signed Student Information (Section-1 & 2).'
            }
            else if(this.selectedSectionForDocUpload == 'I983Employer')
            {
                 return 'Please upload the physically signed Employer Information (Section-3 & 4).'
            }
            else if(this.selectedSectionForDocUpload == 'I983AssignedTraining')
            {
                 return 'Please upload the physically signed Training Plan (section-5 & 6).'
            }
        },

        TitleForUpload()
        {
            if(this.selectedSectionForDocUpload == 'I983')
            {
                 return 'complete I-983 form'
            }
            else if(this.selectedSectionForDocUpload == 'I983Evaluation')
            {
                  return 'student evaluation section'
            }
            else if(this.selectedSectionForDocUpload == 'I983Student')
            {
                 return 'student information section'
            }
            else if(this.selectedSectionForDocUpload == 'I983Employer')
            {
                 return 'employer information section'
            }
            else if(this.selectedSectionForDocUpload == 'I983AssignedTraining')
            {
                 return 'Training plan Section'
            }
        },
        IsEvaluationVerifiedBySupervisor()
        {
           return this.content && this.content.Evaluation && this.content.Evaluation.IsSupervisorVerified
        },
        IsSignedDocumentForStudentExist()
        {
           if(this.content && this.content.Employee && this.content.Employee.SignedDocument && this.content.Employee.SignedDocument.DocumentUrl != '' && this.content.Employee.SignedDocument.DocumentUrl != null)
           {
              return true
           }
           else return false
        },
        IsSignedDocumentForEmployerExist()
        {
           if(this.content && this.content.Employer && this.content.Employer.SignedDocument && this.content.Employer.SignedDocument.DocumentUrl != '' && this.content.Employer.SignedDocument.DocumentUrl != null)
           {
              return true
           }
           else return false
        },
        IsSignedDocumentForEvaluationExist()
        {
           if(this.content && this.content.Evaluation && this.content.Evaluation.SignedDocument && this.content.Evaluation.SignedDocument.DocumentUrl != '' && this.content.Evaluation.SignedDocument.DocumentUrl != null)
           {
              return true
           }
           else return false
        },
        IsSignedDocumentForAssignedTrainingExist()
        {
           if(this.content && this.content.AssignedTraining && this.content.AssignedTraining.SignedDocument && this.content.AssignedTraining.SignedDocument.DocumentUrl != '' && this.content.AssignedTraining.SignedDocument.DocumentUrl != null)
           {
              return true
           }
           else return false
        },
        SignedDocumentUrlForStudent() {
            if(this.content.Employee && this.content.Employee.SignedDocument && this.content.Employee.SignedDocument.DocumentUrl) {
                return this.content.Employee.SignedDocument.DocumentUrl;
            }

            return ''
        },
        SignedDocumentUrlForEvalution() {
            if(this.content.SignatureType == "Inc" && this.content.Evaluation && this.content.Evaluation.SignedDocument && this.content.Evaluation.SignedDocument.DocumentUrl) {
                return this.content.Evaluation.SignedDocument.DocumentUrl;
            }
            else if(this.content.SignatureType == "Electronic" && this.content && this.content.SignedDocument && this.content.SignedDocument.DocumentUrl) {
                return this.content.SignedDocument.DocumentUrl;
            } 
            return ''
        },
        SignedDocumentUrlForEmployer() {
            if(this.content.SignatureType == "Inc" && this.content.Employer && this.content.Employer.SignedDocument && this.content.Employer.SignedDocument.DocumentUrl) {
                return this.content.Employer.SignedDocument.DocumentUrl;
            }
            else if(this.content.SignatureType == "Electronic" && this.content && this.content.SignedDocument && this.content.SignedDocument.DocumentUrl) {
                return this.content.SignedDocument.DocumentUrl;
            }
            return ''
        },
        SignedDocumentUrlForAssignedTraining() {
            if(this.content.AssignedTraining && this.content.AssignedTraining.SignedDocument && this.content.AssignedTraining.SignedDocument.DocumentUrl) {
                return this.content.AssignedTraining.SignedDocument.DocumentUrl;
            }

            return ''
        },

        SignedDocumentFileNameForStudent() {
            return utils.I9URL2FileName(this.SignedDocumentUrlForStudent);
        },
        SignedDocumentFileNameForEvalution() {
            return utils.I9URL2FileName(this.SignedDocumentUrlForEvalution);
        },
        SignedDocumentFileNameForEmployer() {
            return utils.I9URL2FileName(this.SignedDocumentUrlForEmployer);
        },
        SignedDocumentFileNameForAssignedTraining() {
            return utils.I9URL2FileName(this.SignedDocumentUrlForAssignedTraining);
        },

        CompletedDateForStudent() {
            return this.content.Employee.SignedDocument && this.content.Employee.SignedDocument.SignedDateString ? this.content.Employee.SignedDocument.SignedDateString : '-';
        },
        CompletedDateForEvalution() {
            return this.content.Evaluation.SignedDocument && this.content.Evaluation.SignedDocument.SignedDateString ? this.content.Evaluation.SignedDocument.SignedDateString : '-';
        },
        CompletedDateForEmployer() {
            return this.content.Employer.SignedDocument && this.content.Employer.SignedDocument.SignedDateString ? this.content.Employer.SignedDocument.SignedDateString : '-';
        },
        CompletedDateForAssignedTraining() {
            return this.content.AssignedTraining.SignedDocument && this.content.AssignedTraining.SignedDocument.SignedDateString ? this.content.AssignedTraining.SignedDocument.SignedDateString : '-';
        },

        StudentSignedDocumentSharedLogs() {
            if(this.content.Employee.SignedDocument && this.content.Employee.SignedDocument.SharedLog) {
                return this.content.Employee.SignedDocument.SharedLog.filter(v=> {
                                                      return v.CreatedBy.Email == this.loggedInUserEmail});
            } else {
                return [];
            }
        },
        EmployerSignedDocumentSharedLogs() {
            if(this.content.Employer.SignedDocument && this.content.Employer.SignedDocument.SharedLog) {
                return this.content.Employer.SignedDocument.SharedLog.filter(v=> {
                                                      return v.CreatedBy.Email == this.loggedInUserEmail});
            } else {
                return [];
            }
        },
        EvaluationSignedDocumentSharedLogs() {
            if(this.content.Evaluation.SignedDocument && this.content.Evaluation.SignedDocument.SharedLog) {
                return this.content.Evaluation.SignedDocument.SharedLog.filter(v=> {
                                                      return v.CreatedBy.Email == this.loggedInUserEmail});
            } else {
                return [];
            }
        },
        AssignedTrainingSignedDocumentSharedLogs() {
            if(this.content.AssignedTraining.SignedDocument && this.content.AssignedTraining.SignedDocument.SharedLog) {
                return this.content.AssignedTraining.SignedDocument.SharedLog.filter(v=> {
                                                      return v.CreatedBy.Email == this.loggedInUserEmail});
            } else {
                return [];
            }
        },
        StudentSignedDocumentModifiedLogs() {
            if(this.content.Employee.SignedDocument && this.content.Employee.SignedDocument.ModifiedLogs) {

                return this.content.Employee.SignedDocument.ModifiedLogs;
            } else {
                return [];
            }
        },
        EmployerSignedDocumentModifiedLogs() {
            if(this.content.Employer.SignedDocument && this.content.Employer.SignedDocument.ModifiedLogs) {

                return this.content.Employer.SignedDocument.ModifiedLogs;
            } else {
                return [];
            }
        },
        EvaluationSignedDocumentModifiedLogs() {
            if(this.content.Evaluation.SignedDocument && this.content.Evaluation.SignedDocument.ModifiedLogs) {

                return this.content.Evaluation.SignedDocument.ModifiedLogs;
            } else {
                return [];
            }
        },
        AssignedTrainingSignedDocumentModifiedLogs() {
            if(this.content.AssignedTraining.SignedDocument && this.content.AssignedTraining.SignedDocument.ModifiedLogs) {

                return this.content.AssignedTraining.SignedDocument.ModifiedLogs;
            } else {
                return [];
            }
        },



        IsSupervisor()
        {
           if(this.$parent.isSupervisor)
           return true
           else
           return false
        },
        IsEvaluation() {
            if(this.content.Evaluation && this.content.Evaluation.EvaluationFrom)
            {
                return true
            }
        },
        EvaluationStatus() {
             return this.content.Type == 'Evaluation'
        },
        IsMaterialChange() {
            return this.content.Type == 'MaterialChange'
        },
        IsPrimary() {
            return this.content.Type == 'Primary'
        },
        EvaluationObjForUpdate: {
            get() {
                return this.clonedContent;
            },

            set(v) {
                Vue.set(this.clonedContent.Evaluation, 'EvaluationFrom', v.Evaluation.EvaluationFrom);
                Vue.set(this.clonedContent.Evaluation, 'EvaluationTo', v.Evaluation.EvaluationTo);
                Vue.set(this.clonedContent.Evaluation, 'EvaluationSummary', v.Evaluation.EvaluationSummary);
                Vue.set(this.clonedContent.Evaluation, 'IsFinalEvalution', v.Evaluation.IsFinalEvalution);
                Vue.set(this.clonedContent.Evaluation, 'IsSupervisorVerified', v.Evaluation.IsSupervisorVerified);
                Vue.set(this.clonedContent.Evaluation, 'EmployeeSignatureURL', v.Evaluation.EmployeeSignatureURL);
                Vue.set(this.clonedContent.Evaluation, 'EmployeeBase64EncodedSignature', v.Evaluation.EmployeeBase64EncodedSignature);
                Vue.set(this.clonedContent.Evaluation, 'EmployeeSigningType', v.Evaluation.EmployeeSigningType);
                Vue.set(this.clonedContent.Evaluation, 'SignatureURL', v.Evaluation.SignatureURL);
                Vue.set(this.clonedContent.Evaluation, 'Base64EncodedSignature', v.Evaluation.Base64EncodedSignature);
                Vue.set(this.clonedContent.Evaluation, 'SigningType', v.Evaluation.SigningType);
                if(v.EmployeeSignatureURL != '' && v.SignatureURL == '') {

                    Vue.set(this.clonedContent.Evaluation, 'SectionStatus', 'Pending Signature from Employer');
                }else if(v.EmployeeSignatureURL == '' && v.SignatureURL != '') {

                    Vue.set(this.clonedContent.Evaluation, 'SectionStatus', 'Pending Signature from Student');
                }else if(v.EmployeeSignatureURL != '' && v.SignatureURL != '') {

                    Vue.set(this.clonedContent.Evaluation, 'SectionStatus', 'Completed');
                }
            }
        },
        MaterialChangeObjForUpdate: {
            get() {
                return {
                    Id: this.clonedContent.Id,
                    MaterialChange: this.clonedContent.MaterialChange
                };
            },
            set(v) {
                Vue.set(this.clonedContent, 'MaterialChange', v.MaterialChange);

			   // Update the other section contents
                if(v.MaterialChange.MaterialChangeType.indexOf("ChangeOfEmployerIdentificationNumber") > -1) {
                    Vue.set(this.clonedContent.Employer, 'EIN', v.MaterialChange.EIN);
                }

                if(v.MaterialChange.MaterialChangeType.indexOf("ReductionInStudentCompensation") > -1) {
                    Vue.set(this.clonedContent.Employer, 'OPTHours', v.MaterialChange.OPTHours);
                    Vue.set(this.clonedContent.Employer, 'Salary', v.MaterialChange.Salary);
                    Vue.set(this.clonedContent.Employer, 'SalaryFrequency', v.MaterialChange.SalaryFrequency);
                }

                if(v.MaterialChange.MaterialChangeType.indexOf("DecreaseInHoursPerweek") > -1) {
                    Vue.set(this.clonedContent.Employer, 'OPTHours', v.MaterialChange.OPTHours);
                }

                if(v.MaterialChange.MaterialChangeType.indexOf("ChangesCommitmentsOrObjectives") > -1) {
                    Vue.set(this.clonedContent.AssignedTraining.Training, 'Title', v.MaterialChange.Training.Title);
                    Vue.set(this.clonedContent.AssignedTraining.Training, 'StudentRole', v.MaterialChange.Training.StudentRole);
                    Vue.set(this.clonedContent.AssignedTraining.Training, 'Objectives', v.MaterialChange.Training.Objectives);
                    Vue.set(this.clonedContent.AssignedTraining.Training, 'EmployerOverSight', v.MaterialChange.Training.EmployerOverSight);
                    Vue.set(this.clonedContent.AssignedTraining.Training, 'Assessments', v.MaterialChange.Training.Assessments);
                    Vue.set(this.clonedContent.AssignedTraining.Training, 'AdditionalRemarks', v.MaterialChange.Training.AdditionalRemarks);
                }

                if(v.MaterialChange.MaterialChangeType.indexOf("Others") > -1) {
                    Vue.set(this.clonedContent.MaterialChange, 'SpecifyReason', v.MaterialChange.SpecifyReason);
                }
                if(v.MaterialChange.MaterialChangeType.indexOf("ChangeInEmployerSite") > -1) {
                    Vue.set(this.clonedContent.AssignedTraining, 'SiteName', v.AssignedTraining.SiteName);
                    Vue.set(this.clonedContent.AssignedTraining, 'SiteAddress', v.AssignedTraining.SiteAddress);
                    Vue.set(this.clonedContent.Employer.SignatoryAuthority, 'Name', v.Employer.SignatoryAuthority.Name);
                    Vue.set(this.clonedContent.Employer.SignatoryAuthority, 'Title', v.Employer.SignatoryAuthority.Title);
                    Vue.set(this.clonedContent.Employer.SignatoryAuthority, 'Email', v.Employer.SignatoryAuthority.Email);
                    Vue.set(this.clonedContent.Employer.SignatoryAuthority, 'Phone', v.Employer.SignatoryAuthority.Phone);

                    Vue.set(this.clonedContent.MaterialChange, 'SignatoryAuthority', this.clonedContent.Employer.SignatoryAuthority);

                }
            }
        },
        SignedDocumentSharedLogs() {
            if(this.content.SignedDocument && this.content.SignedDocument.SharedLog) {
                return this.content.SignedDocument.SharedLog.filter(v=> {
                                                      return v.CreatedBy.Email == this.loggedInUserEmail});
            } else {
                return [];
            }
        },
        SignedDocumentModifiedLogs() {
            if(this.content.SignedDocument && this.content.SignedDocument.ModifiedLogs) {

                return this.content.SignedDocument.ModifiedLogs;
            } else {
                return [];
            }
        },
        SignedDocumentFileName() {
            return utils.I9URL2FileName(this.SignedDocumentUrl);
        },
        SignedDocumentUrl() {
            if(this.content.SignedDocument && this.content.SignedDocument.DocumentUrl) {
                return this.content.SignedDocument.DocumentUrl;
            }

            return ''
        },
        documentList() {
            let doc = ListOfDocuments[0];
            doc.MetadataValues = [this.fieldValues];
            doc.DocumentType = this.selectedSectionForDocUpload

            return doc;
        },
        documentsTableHeader() {
            return ListOfDocuments[0].Metadata;
        },
        fieldValues: {

            get() {
                let mockObj = {
                "DocumentId": "",
                "DocumentData": []
            }

            this.documentsTableHeader.forEach((h) => {
                mockObj.DocumentData.push({
                    "Key": h.Key,
                    "Value": ""
                })
            })

            if(this.showUploadSignedFormPopupForUpdate == true) {

                if(this.selectedSectionForDocUpload == 'I983')
                {
                    mockObj.DocumentData[0].Value = this.content.SignedDocument.SignedDateString;
                    mockObj.DocumentData[1].Value = this.content.SignedDocument.DocumentUrl;
                }
                else  if(this.selectedSectionForDocUpload == 'I983Evaluation')
                {
                    mockObj.DocumentData[0].Value = this.content.Evaluation.SignedDocument.SignedDateString;
                    mockObj.DocumentData[1].Value = this.content.Evaluation.SignedDocument.DocumentUrl;
               }
                else if(this.selectedSectionForDocUpload == 'I983Student')
                {
                    mockObj.DocumentData[0].Value = this.content.Employee.SignedDocument.SignedDateString;
                    mockObj.DocumentData[1].Value = this.content.Employee.SignedDocument.DocumentUrl;
                }
                else if(this.selectedSectionForDocUpload == 'I983Employer')
                {
                    mockObj.DocumentData[0].Value = this.content.Employer.SignedDocument.SignedDateString;
                    mockObj.DocumentData[1].Value = this.content.Employer.SignedDocument.DocumentUrl;
                }
                else if(this.selectedSectionForDocUpload == 'I983AssignedTraining')
                {
                    mockObj.DocumentData[0].Value = this.content.AssignedTraining.SignedDocument.SignedDateString;
                    mockObj.DocumentData[1].Value = this.content.AssignedTraining.SignedDocument.DocumentUrl;
                }
            }
            return mockObj
            },

            set(v) {
                this.fieldValues.DocumentData[0].Value = '';
                this.fieldValues.DocumentData[1].Value = '';
            }


        },
        documentType() {
            return this.documentList.DocumentType
        },
        fileUploadUrl() {
            return `/OnBoard/UpdateDocumentByGroup?consultantId=${this.$route.params.id}&orgId=${loggedInUserObj.orgId}&jobId=&i983Id=${this.content.Id}`
        },
        InitiatedDate() {
            return this.content.CreatedDate
        },
        CompletedDate() {
            if(this.content.IsInitiateOnlySectionType && this.content.IsInitiated)
            {
                if(this.content.Type == 'Evaluation' && this.content.Evaluation.SectionStatus == 'Completed')
                {
                     return this.content.Evaluation.SignedDocument && this.content.Evaluation.SignedDocument.SignedDateString ? this.content.Evaluation.SignedDocument.SignedDateString: '-';
                }
                else if(this.content.Type == 'MaterialChange' && this.content.Employer.SectionStatus == 'Completed' && this.showCollapse('Employer') && !this.IsMultipleMaterialChange())
                {
                    return this.content.Employer.SignedDocument && this.content.Employer.SignedDocument.SignedDateString ? this.content.Employer.SignedDocument.SignedDateString : '-';
                }
                else if(this.content.Type == 'MaterialChange' && this.content.AssignedTraining.SectionStatus == 'Completed' && this.showCollapse('Training') && !this.IsMultipleMaterialChange())
                {
                    return this.content.AssignedTraining.SignedDocument && this.content.AssignedTraining.SignedDocument.SignedDateString ? this.content.AssignedTraining.SignedDocument.SignedDateString : '-';
                }
            }
            return this.content.SignedDocument && this.content.SignedDocument.SignedDateString ? this.content.SignedDocument.SignedDateString : '-';
        },
        loggedInUserEmail() {
            return this.loggedInUserObj.Email || this.loggedInUserObj.email || '';
        },
        InitiatedBy() {
            // if(this.content.CreatedBy.Email == this.loggedInUserEmail) {
            //     return 'You';
            // } else {
            //     return this.content.CreatedBy && this.content.CreatedBy.FirstName ? this.content.CreatedBy.FirstName + ' ' + this.content.CreatedBy.LastName : '-';
            // }
            return this.content.CreatedBy && this.content.CreatedBy.FirstName ? this.content.CreatedBy.FirstName + ' ' + this.content.CreatedBy.LastName : '-';
        },
        clonedContent: {
            get() {
                return this.content;
            },

            set(val) {
                this.$emit('update:content', val);
            }
        },
        Employee() {
            return this.content.Employee || {};
        },
        Employer() {
            return this.content.Employer || {};
        },
        AssignedTraining() {
            return this.content.AssignedTraining || {};
        },
        Evaluation() {
            return this.content.Evaluation || {};
        },
        evaluationTheme() {
            if(this.Evaluation.SectionStatus == 'PendingFromStudent') {
                if(this.isHRManager) {
                    return 'warning';
                } else {
                    return 'default';
                }
            }

            return 'primary';
        },
        trainingPlanTheme() {
            if(this.AssignedTraining.SectionStatus == 'PendingFromStudent') {
                if(this.isHRManager) {
                    return 'warning';
                } else {
                    return 'default';
                }
            }

            return 'primary';
        },
        employerInfoTheme() {
            if(this.Employer.SectionStatus == 'NotInitiated') {
                return 'default';
            }

            return 'primary';
        },
        studentInfoTheme() {
            if(this.Employee.SectionStatus == 'PendingFromStudent') {
                if(this.isHRManager) {
                    return 'warning';
                } else {
                    return 'default';
                }
            }

            return 'primary';
        }

    
    },
    watch: {

        showUploadSignedFormPopup(val) {
            if(val === true) {
                setTimeout(() => {
                    // alert('')
                    // this.$refs.dynamicformfield.$children[0].data.minDate = moment(.;
                }, 2000);
            }
        },
        'clonedContent.Employee.SignedDocumentStatus': function (newValue, oldValue) {
            this.UpdateOverAllStatus();
        },
        'clonedContent.Employer.SignedDocumentStatus': function (newValue, oldValue) {
            this.UpdateOverAllStatus();
        },
        'clonedContent.AssignedTraining.SignedDocumentStatus': function (newValue, oldValue) {
            this.UpdateOverAllStatus();
        },
        'clonedContent.Evaluation.SignedDocumentStatus': function (newValue, oldValue) {
            this.UpdateOverAllStatus();
        }
    },
    created(){
    //    this.getLoggedInUserDetails()
       var user = localStorage.getItem('user_details');
        if(user != null && user != 'undefined'){
            var userDetails = JSON.parse(user);
            this.userDetails = userDetails;
        }
    },
    methods: {
        UpdateOverAllStatus()
        {
            if(this.clonedContent.SignatureType == "Electronic")
            {
                if(this.clonedContent.Type == "Primary")
                {
                    if(this.clonedContent.Employee.SectionStatus == "Completed" && this.clonedContent.Employee.SignedDocumentStatus == ""
                    && this.clonedContent.Employer.SectionStatus == "Completed" && this.clonedContent.Employer.SignedDocumentStatus == ""
                     && this.clonedContent.AssignedTraining.SectionStatus == "Completed" && this.clonedContent.AssignedTraining.SignedDocumentStatus == "")
                    {
                       setTimeout(() => {
                        console.log('I983-Over all Status will be updated..')
                        this.$parent.$parent.fetchData('fromSignaR');
                       }, 5*1000);
                    }
                }
                if(this.clonedContent.Type == "MaterialChange")
                {
                    if(this.clonedContent.Employee.SectionStatus == "Completed" && this.clonedContent.Employee.SignedDocumentStatus == ""
                     && this.clonedContent.Employer.SectionStatus == "Completed" && this.clonedContent.Employer.SignedDocumentStatus == ""
                     && this.clonedContent.AssignedTraining.SectionStatus == "Completed" && this.clonedContent.AssignedTraining.SignedDocumentStatus == "")
                    {
                       setTimeout(() => {
                        console.log('I983-Over all Status will be updated..')
                        this.$parent.$parent.fetchData('fromSignaR');
                       }, 5*1000);
                    }
                    else if(this.clonedContent.IsInitiateOnlySectionType
                     && this.clonedContent.AssignedTraining.SectionStatus == "Completed" && this.clonedContent.AssignedTraining.SignedDocumentStatus == "")
                    {
                       setTimeout(() => {
                        console.log('I983-Over all Status will be updated..')
                        this.$parent.$parent.fetchData('fromSignaR');
                       }, 5*1000);
                    }
                    else if(this.clonedContent.IsInitiateOnlySectionType
                     && this.clonedContent.Employer.SectionStatus == "Completed" && this.clonedContent.Employer.SignedDocumentStatus == "")
                    {
                       setTimeout(() => {
                        console.log('I983-Over all Status will be updated..')
                        this.$parent.$parent.fetchData('fromSignaR');
                       }, 5*1000);
                    }
                    
                }
                if(this.clonedContent.Type == "Evaluation")
                {
                    if(this.clonedContent.IsInitiateOnlySectionType
                    && this.clonedContent.Evaluation.SectionStatus == "Completed" && this.clonedContent.Evaluation.SignedDocumentStatus == ""
                    )
                    {
                       setTimeout(() => {
                        console.log('I983-Over all Status will be updated..')
                        this.$parent.$parent.fetchData('fromSignaR');
                       }, 5*1000);
                    }
                    else if(this.clonedContent.Employee.SectionStatus == "Completed" && this.clonedContent.Employee.SignedDocumentStatus == ""
                    && this.clonedContent.Employer.SectionStatus == "Completed" && this.clonedContent.Employer.SignedDocumentStatus == ""
                    && this.clonedContent.AssignedTraining.SectionStatus == "Completed" && this.clonedContent.AssignedTraining.SignedDocumentStatus == ""
                    && this.clonedContent.Evaluation.SectionStatus == "Completed" && this.clonedContent.Evaluation.SignedDocumentStatus == ""
                    )
                    {
                       setTimeout(() => {
                        console.log('I983-Over all Status will be updated..')
                        this.$parent.$parent.fetchData('fromSignaR');
                       }, 5*1000);
                    }
                }
            }
        },
        SendEmail(section){
            this.$loading()
            ajax.get(`I983/ResendMail?id=${this.content.Id}&sectionType=${section}`, {}, (res) =>{
                this.$loading().close()
                this.$message({
                    type:'success',
                    message: 'Email sent successfully',
                })
            })
        },
        SignatoryChange(type) { 
         if(type) {
          this.ChangeSAType = type
             }
             this.isChangeSignAuth = true;
             },
        incompleteSectionMessage() {
           return "This section is incomplete. Completing it will pre-populate this data for other sections, such as Student Evaluation and Material Change.";
        },

        handleEvaluationStatus(val) {
        if(this.content.SignatureType == 'Electronic' && val.SignedDocumentStatus == 'Pending Physical Signature') {
                if(val.Base64EncodedSignature && val.SignatureURL &&  val.SignatureURL != '') {
                return 'Pending Signature from Student'
                }else{
                return 'Pending Signature from Employer'
                }
            }else {
                return val.SignedDocumentStatus;
                }
              
        },
            IsPhysically(signatureType)
            {
                if(signatureType == 'Electronic')
                {
                    return '' ;
                }
                else
                {
                    return 'Physical'
                }
            },
            IsMultipleMaterialChange()
            {
                if(this.content.Type == 'MaterialChange' && this.content.IsInitiateOnlySectionType && this.content.IsInitiated)
                {
                    if(this.content.MaterialChange != null && this.content.MaterialChange.MaterialChangeType != null)
                    {
                            if((this.content.MaterialChange.MaterialChangeType.indexOf("ChangeOfEmployerIdentificationNumber") > -1 || this.content.MaterialChange.MaterialChangeType.indexOf("ReductionInStudentCompensation") > -1 || this.content.MaterialChange.MaterialChangeType.indexOf("DecreaseInHoursPerweek") > -1 || this.content.MaterialChange.MaterialChangeType.indexOf("Others") > -1 || this.content.MaterialChange.MaterialChangeType.indexOf("PeriodicEvaluationFromTheUniversity") > -1)
                            &&(this.content.MaterialChange.MaterialChangeType.indexOf("ChangesCommitmentsOrObjectives") > -1 || this.content.MaterialChange.MaterialChangeType.indexOf("PeriodicEvaluationFromTheUniversity") > -1 || this.content.MaterialChange.MaterialChangeType.indexOf("ChangeInEmployerSite") > -1 || this.content.MaterialChange.MaterialChangeType.indexOf("Others") > -1))
                            {
                                return true;
                            }
                    }
                }
                return false;
            },
            showCollapse(type)
            {
                if(this.content.IsInitiateOnlySectionType && this.content.IsInitiated)
                {
                    if(this.content.Type == 'Evaluation')
                    {
                        return false
                    }
                    else if(this.content.Type == 'MaterialChange')
                    {
                        if(type == 'Employer' && (this.content.MaterialChange.MaterialChangeType.indexOf("ChangeOfEmployerIdentificationNumber") > -1 || this.content.MaterialChange.MaterialChangeType.indexOf("ReductionInStudentCompensation") > -1 || this.content.MaterialChange.MaterialChangeType.indexOf("DecreaseInHoursPerweek") > -1 || this.content.MaterialChange.MaterialChangeType.indexOf("PeriodicEvaluationFromTheUniversity") > -1 || this.content.MaterialChange.MaterialChangeType.indexOf("Others") > -1))
                        {
                            return true
                        }
                        if(type == 'Training' && (this.content.MaterialChange.MaterialChangeType.indexOf("ChangesCommitmentsOrObjectives") > -1 || this.content.MaterialChange.MaterialChangeType.indexOf("PeriodicEvaluationFromTheUniversity") > -1 || this.content.MaterialChange.MaterialChangeType.indexOf("ChangeInEmployerSite") > -1 || this.content.MaterialChange.MaterialChangeType.indexOf("Others") > -1))
                        {
                            return true
                        }
                        return false
                    }
                    return false;
                }
                else if(!this.content.IsInitiated)
                {
                    return false;
                }
                return true
            },
            onCompleteButtonClicked()
            {
                this.IsCompleteButton = false;
            },
            resetUploadPopup(){
              this.doValidation = false;
              this.fieldValues = '';
            },
            resetAttachmentpopup()
            {
            this.SupportingLinks= '',
            this.SupportingDocuments = [{
                            DocUrl:'',
                            Id:''
                }]
            },
          cancelAttachmentDoc()
          {
            this.resetAttachmentpopup();
            this.showAddAttachmentsPopup=false
          },
          confirmDeleteDocuments(doc,Isdoc,index) {
                this.$alert2("Are you sure you want to delete ?", "Alert", {
                    type: "confirm",
                    yesButtonText: "Yes",
                    noButtonText: "No",
                    callback: (action) => {
                        if(action === true) {
                           this.deleteAttachment(doc,Isdoc,index)
                        }
                    }
                });
            },
             guid() {
                function s4() {
                    return Math.floor((1 + Math.random()) * 0x10000)
                        .toString(16)
                        .substring(1);
                }
                return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
                    s4() + '-' + s4() + s4() + s4();
            },
            cancelAddPopup() {
            this.openAddUnTrustedSitesPopUp = false;
            },
            AddTrustedSitesLinkPopup() {
            ajax.put(`Task/AddTrustedSites`, this.SupportingLinks, res => {
            
            if (res.data.State == true) {
                this.openAddUnTrustedSitesPopUp = false
                this.$message({
                    type: "success",
                    message: "Attachment/Link added successfully"
                });
                }
            else{
                    this.$message({
                    type: 'error',
                    message: res.data.Message
                    
                });
                this.$loading({}).close();
                }
            });
            },

            addNewAttachment()
            {
                    for(var i=0 ; i < this.SupportingDocuments.length ; i++)
                    {
                        this.SupportingDocuments[i].Id = this.guid();
                    }


                this.$loading({ loadingText: "Updating..." });
                                     var supportingLinks = this.SupportingLinks
                        var params = {
                        SupportingDocument:this.SupportingDocuments.filter(v=> {
                                                      return v.DocUrl!='' && v.DocUrl!= null}),
                        SupportingLink:supportingLinks
                        };
                   ajax.put(`/I983/${this.content.Id}/AddDocument`, params, res => {
                    if (res.data.State == true) {

                        var supportingLinks = this.SupportingLinks;

                        var docs = this.SupportingDocuments.filter(v=> {
                                                      return v.DocUrl!='' && v.DocUrl!= null})
                        for(var i=0 ; i < supportingLinks.length ; i++)
                        {
                            this.content.AssignedTraining.Training.SupportingLink.push(supportingLinks[i]);
                        }
                        for(var i=0 ; i < docs.length ; i++)
                        {
                            this.content.AssignedTraining.Training.SupportingDocument.push(docs[i])
                        }
                           this.resetAttachmentpopup();
                           this.showAddAttachmentsPopup = false;
                        this.$message({
                        type: "success",
                        message: "Attachment added successfully!"
                        });
                         this.$loading().close()
                    }
                    else{
                        this.$loading().close()
                        //this.ESSEnableDisable(res)
                        this.openAddUnTrustedSitesPopUp = true
                    }
                });
             },
            deleteAttachment(doc,Isdoc ,index)
            {
                     this.$loading({ loadingText: "Deleting..." });


                        var supportingLink = !Isdoc ? doc: null;
                        var id =  Isdoc ? doc : null;
                    ajax.put(`/I983/${this.content.Id}/Remove?isDoc= ${Isdoc}&documentId=${id}&link=${supportingLink}`, {}, res => {
                    if (res.data.State == true) {

                       if(!Isdoc) {
                            this.content.AssignedTraining.Training.SupportingLink.splice(index, 1);
                        }
                        else if(Isdoc) {
                            this.content.AssignedTraining.Training.SupportingDocument.splice(index, 1);
                        }
                        this.$message({
                        type: "success",
                        message: "Attachment removed successfully!"
                        });
                         this.$loading().close()
                    }
                    else{
                        this.$loading().close()
                        this.ESSEnableDisable(res)
                    }
                });
             },

            addDocument(arr) {
                            arr.push({
                            DocUrl:'',
            })
            },
            removeDocument(index)
            {
                this.SupportingDocuments.splice(index, 1)
            },

            uploadComplete(index, fileQueue) {
                if (fileQueue && fileQueue[0].response && fileQueue[0].response.Url) {
                    this.SupportingDocuments[index].DocUrl = fileQueue[0].response.Url
                    this.SupportingDocuments[index].isErrorMessageDisabled=false
                }
                if (fileQueue[0].response.State==false && fileQueue[0].response.Message!=null)
                {
                    this.SupportingDocuments[index].isErrorMessageDisabled=true
                    this.SupportingDocuments[index].errorMessageFrmResponse=fileQueue[0].response.Message
                    this.$refs.child1[index].CancelUpload()
                }
            },
        _HasMaterialChangeType(type) {
            return this.content.MaterialChange.MaterialChangeType && this.content.MaterialChange.MaterialChangeType.indexOf(type) !== -1;
        },
        _getHumanSalaryFrequency(salaryFrequency) {
            if(salaryFrequency == 'BiWeekly') {
                return 'Bi-Weekly';
            } else if(salaryFrequency == 'SemiMonthly') {
                return 'Semi-Monthly';

            } else {
                return salaryFrequency;
            }
        },
        _showUploadSignedFormPopupForUpload(docSectionType)
        {
            this.selectedSectionForDocUpload = docSectionType
            this.showUploadSignedFormPopup = true;
            if(this.content.SignedDocument != null)
            {
               this.showUploadSignedFormPopupForUpdate = true;
            }
        },
        _showUploadSignedFormPopup(docSectionType) {

            this.selectedSectionForDocUpload = docSectionType
            this.showUploadSignedFormPopup = true;
            this.showUploadSignedFormPopupForUpdate = false;
            this.resetUploadPopup();
        },
        _showUploadSignedFormPopupForUpdate(docSectionType) {
            this.selectedSectionForDocUpload = docSectionType
            this.showUploadSignedFormPopup = true;
            this.showUploadSignedFormPopupForUpdate = true;
        },
        ViewSignedDocument(url) {
             utils.previewSingleDoc(url)
            //window.open(utils.getFilePreviewLink(url), '_blank');
        },
        DownloadSignedDocument(url) {
           utils.downloadSingleDoc(url)
            //window.open(utils.getFileDownloadLink(url), '_blank');
        },
        InitiateEmployerInformation() {
            this.showInitiateEmployerPopupForUpdate = false;
            this.showInitiateEmployerPopup = true;
        },
        UpdateTrainingPlanPopup(){
            this.IsReviewTrainingPlan = true;
            this.showUpdateTrainingPlanPopup = true;
        },
        UpdateEmployerInformation() {
            this.showInitiateEmployerPopupForUpdate = true;
            this.showInitiateEmployerPopup = true;
        },
        _UpdateLocalSignedDocumentObject(){
            if(this.selectedSectionForDocUpload == 'I983')
            {
                    let SignedDocument = {
                         SignedDateString: this.fieldValues.DocumentData[0].Value,
                         DocumentUrl: this.fieldValues.DocumentData[1].Value,
                         SharedLog : this.clonedContent.SignedDocument && this.clonedContent.SignedDocument.SharedLog ? this.clonedContent.SignedDocument.SharedLog : null,
                         ModifiedLogs : this.clonedContent.SignedDocument && this.clonedContent.SignedDocument.ModifiedLogs ? this.clonedContent.SignedDocument.ModifiedLogs : null,
                    }

                Vue.set(this.clonedContent, 'SignedDocument', SignedDocument);
                Vue.set(this.clonedContent, 'Status', 'Completed');

                this.$parent.insertModifiedLogToStore('SignedForm');
            }
            else if(this.selectedSectionForDocUpload == 'I983Evaluation')
            {
                 let SignedDocument = {
                         SignedDateString: this.fieldValues.DocumentData[0].Value,
                         DocumentUrl: this.fieldValues.DocumentData[1].Value,
                         SharedLog : this.clonedContent.Evaluation.SignedDocument && this.clonedContent.Evaluation.SignedDocument.SharedLog ? this.clonedContent.Evaluation.SignedDocument.SharedLog : null,
                         ModifiedLogs : this.clonedContent.Evaluation.SignedDocument && this.clonedContent.Evaluation.SignedDocument.ModifiedLogs ? this.clonedContent.Evaluation.SignedDocument.ModifiedLogs : null,
                    }

                Vue.set(this.clonedContent.Evaluation, 'SignedDocument', SignedDocument);

                this.$parent.insertModifiedLogToStore('I983Evaluation');
            }
            else if(this.selectedSectionForDocUpload == 'I983Student')
            {
                 let SignedDocument = {
                         SignedDateString: this.fieldValues.DocumentData[0].Value,
                         DocumentUrl: this.fieldValues.DocumentData[1].Value,
                         SharedLog : this.clonedContent.Employee.SignedDocument && this.clonedContent.Employee.SignedDocument.SharedLog ? this.clonedContent.Employee.SignedDocument.SharedLog : null,
                         ModifiedLogs : this.clonedContent.Employee.SignedDocument && this.clonedContent.Employee.SignedDocument.ModifiedLogs ? this.clonedContent.Employee.SignedDocument.ModifiedLogs : null,
                    }

                Vue.set(this.clonedContent.Employee, 'SignedDocument', SignedDocument);

                this.$parent.insertModifiedLogToStore('I983Student');
            }
            else if(this.selectedSectionForDocUpload == 'I983Employer')
            {
                let SignedDocument = {
                         SignedDateString: this.fieldValues.DocumentData[0].Value,
                         DocumentUrl: this.fieldValues.DocumentData[1].Value,
                         SharedLog : this.clonedContent.Employer.SignedDocument && this.clonedContent.Employer.SignedDocument.SharedLog ? this.clonedContent.Employer.SignedDocument.SharedLog : null,
                         ModifiedLogs : this.clonedContent.Employer.SignedDocument && this.clonedContent.Employer.SignedDocument.ModifiedLogs ? this.clonedContent.Employer.SignedDocument.ModifiedLogs : null,
                    }

                Vue.set(this.clonedContent.Employer, 'SignedDocument', SignedDocument);

                this.$parent.insertModifiedLogToStore('I983Employer');
            }
            else if(this.selectedSectionForDocUpload == 'I983AssignedTraining')
            {
                let SignedDocument = {
                         SignedDateString: this.fieldValues.DocumentData[0].Value,
                         DocumentUrl: this.fieldValues.DocumentData[1].Value,
                         SharedLog : this.clonedContent.AssignedTraining.SignedDocument && this.clonedContent.AssignedTraining.SignedDocument.SharedLog ? this.clonedContent.AssignedTraining.SignedDocument.SharedLog : null,
                         ModifiedLogs : this.clonedContent.AssignedTraining.SignedDocument && this.clonedContent.AssignedTraining.SignedDocument.ModifiedLogs ? this.clonedContent.AssignedTraining.SignedDocument.ModifiedLogs : null,
                    }

                Vue.set(this.clonedContent.AssignedTraining, 'SignedDocument', SignedDocument);

                this.$parent.insertModifiedLogToStore('I983AssignedTraining');
            }

        },
        uploadSignedForm() {
         this.doValidation = true;
         this.$refs.dynamicformfield.checkIsFormValid();
            if(this.isFormValid === true) {
                this.$loading({"loadingText": "Uploading..."});
                this.uploadDocument(this.documentList, this.fieldValues).then((res) => {
                    if (res.data.State === true) {
                            this.showUploadSignedFormPopup = false;
                            this.$loading({"loadingText": "Uploading..."}).close();
                            this.$message({
                                type: "success",
                                message: this.showUploadSignedFormPopupForUpdate ? "Signed Form updated successfully." :  "Signed Form uploaded successfully."
                            });
                            this._UpdateLocalSignedDocumentObject();

                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.Message
                            })
                        }

                        this.$loading().close()
                });
            }
        },
         previewDocument(sectionType,Obj) {
             this.previewSectionType = sectionType
            this.$loading({loadingText: 'Please wait...'});
            ajax.put(`/I983/Preview?sectionType=${sectionType}&empOrgId=${loggedInUserObj.orgId}`, Obj, (res) => {
                if(res.data.State === true) {
                       this.showPreviewPopup = true
                       this.previewURL = res.data.I983DocUrl
                } else {
                    this.ESSEnableDisable(res)
                    this.$message({
                        type: 'error',
                        message: res.data.Message
                    })
                }

                this.$loading({}).close();
            });
        },
        savePreview(sectionType)
        {
            if(sectionType == 'Employer')
            {
                this.$refs.employer.updateEmployerDetails()
            }
            else if(sectionType == 'AssignedTraining')
            {
                this.$refs.assignedTraining.updateTrainingPlan()
                //this.$parent.$parent.fetchData() //Should be handled in local
            }
            else if(sectionType == 'Student')
            {
                this.$refs.student.updateStudentDetails()
            }
            else if(sectionType == 'Evaluation')
            {
                this.$refs.evaluation.makeUpdateAPICall()
            }
            this.showPreviewPopup = false
            if(this.content.SignatureType == 'Electronic') {
                this.UpdateLocalSignedDocumentObjectForElectronicFlow(sectionType);
            }
        },
        UpdateLocalSignedDocumentObjectForElectronicFlow(sectionType){
          if(sectionType == 'I983')
          {
                  let SignedDocument = {
                       SignedDateString: moment().format('MM/DD/YYYY'),
                       DocumentUrl: this.previewURL,
                       SharedLog : this.clonedContent.SignedDocument && this.clonedContent.SignedDocument.SharedLog ? this.clonedContent.SignedDocument.SharedLog : null,
                       ModifiedLogs : this.clonedContent.SignedDocument && this.clonedContent.SignedDocument.ModifiedLogs ? this.clonedContent.SignedDocument.ModifiedLogs : null,
                  }

              Vue.set(this.clonedContent, 'SignedDocument', SignedDocument);
              Vue.set(this.clonedContent, 'Status', 'Completed');

              this.$parent.insertModifiedLogToStore('SignedForm');
          }
          else if(sectionType == 'Evaluation')
          {
            if(this.clonedContent.Evaluation.SignedDate && this.clonedContent.Evaluation.SignedDate != "")
            {
               let SignedDocument = {
                       SignedDateString: moment().format('MM/DD/YYYY'),
                       DocumentUrl: this.previewURL,
                       SharedLog : this.clonedContent.Evaluation.SignedDocument && this.clonedContent.Evaluation.SignedDocument.SharedLog ? this.clonedContent.Evaluation.SignedDocument.SharedLog : null,
                       ModifiedLogs : this.clonedContent.Evaluation.SignedDocument && this.clonedContent.Evaluation.SignedDocument.ModifiedLogs ? this.clonedContent.Evaluation.SignedDocument.ModifiedLogs : null,
                  }

              Vue.set(this.clonedContent.Evaluation, 'SignedDocument', SignedDocument);
            }

              this.$parent.insertModifiedLogToStore('I983Evaluation');
            // this.$parent.$parent.fetchData()


                
          }
          else if(sectionType == 'Student')
          {
               let SignedDocument = {
                       SignedDateString: moment().format('MM/DD/YYYY'),
                       DocumentUrl: this.previewURL,
                       SharedLog : this.clonedContent.Employee.SignedDocument && this.clonedContent.Employee.SignedDocument.SharedLog ? this.clonedContent.Employee.SignedDocument.SharedLog : null,
                       ModifiedLogs : this.clonedContent.Employee.SignedDocument && this.clonedContent.Employee.SignedDocument.ModifiedLogs ? this.clonedContent.Employee.SignedDocument.ModifiedLogs : null,
                  }

              Vue.set(this.clonedContent.Employee, 'SignedDocument', SignedDocument);

              this.$parent.insertModifiedLogToStore('I983Student');
          }
          else if(sectionType == 'Employer')
          {
              let SignedDocument = {
                       SignedDateString: moment().format('MM/DD/YYYY'),
                       DocumentUrl: this.previewURL,
                       SharedLog : this.clonedContent.Employer.SignedDocument && this.clonedContent.Employer.SignedDocument.SharedLog ? this.clonedContent.Employer.SignedDocument.SharedLog : null,
                       ModifiedLogs : this.clonedContent.Employer.SignedDocument && this.clonedContent.Employer.SignedDocument.ModifiedLogs ? this.clonedContent.Employer.SignedDocument.ModifiedLogs : null,
                  }

              Vue.set(this.clonedContent.Employer, 'SignedDocument', SignedDocument);

              this.$parent.insertModifiedLogToStore('I983Employee');
          }
          else if(sectionType == 'AssignedTraining')
          {
            let _that = this;
            setTimeout(() => {
                if(_that.clonedContent.AssignedTraining.IsSignedBySupervisor && _that.IsSupervisor)
                {
                    let SignedDocument = {
                            SignedDateString: moment().format('MM/DD/YYYY'),
                            DocumentUrl: _that.previewURL,
                            SharedLog : _that.clonedContent.AssignedTraining.SignedDocument && _that.clonedContent.AssignedTraining.SignedDocument.SharedLog ? _that.clonedContent.AssignedTraining.SignedDocument.SharedLog : null,
                            ModifiedLogs : _that.clonedContent.AssignedTraining.SignedDocument && _that.clonedContent.AssignedTraining.SignedDocument.ModifiedLogs ? _that.clonedContent.AssignedTraining.SignedDocument.ModifiedLogs : null,
                        }
                    
                    Vue.set(_that.clonedContent.AssignedTraining, 'SignedDocument', SignedDocument);
                    _that.$parent.insertModifiedLogToStore('I983AssignedTraining');
                }
            }, 8000);
          }

       },
        uploadDocument(documentList, fieldValues) {
            let model = Object.assign({}, documentList)

            model.MetadataValues = [fieldValues]

            let obj = model

            return new Promise((resolve, reject) => {
                ajax.put(this.fileUploadUrl, obj, (res) => {
                    if(res.data.State === true) {
                       resolve(res)
                    }
                    else
                    this.ESSEnableDisable(res)
                })
            })
        },
         linkUrl(link)
         {
           return 'https://'+link
         }
    }
}
</script>
<style scoped>
.blue-text {
        color: blue;
    }
.complete_style{
    color:#D0032E;
    font-weight: 600;
    font-size: 15px;
}
.complete_button{
    font-weight: 600;
    font-size: 13px;
    text-decoration: underline;
}
.section-details-status-text {
    font-weight: 600;
    margin-bottom: 15px;
    font-size: 12px;
}
.control-label {
    color: #8695A5;
}
.form-control-static {
    color: #475259;
    font-weight: 600;
    word-break: break-word;
    overflow-wrap: anywhere;
    white-space: normal;
    max-height: 200px;
    overflow-y: auto;
}
.section-title {
    color: #4D92DF;
    font-size: 13px;
    margin: 0 0 15px;
    font-weight: 600;
}
.section{
    color: rgb(103, 106, 108);
    font-size: 13px;
    margin: 0 0 15px;
    font-weight: 600;
}
.label {
    border-radius: 10px;
}
.doc-links-view
{
    margin: 1%;
    margin-left: 0px;
    border: 1px solid #1dc942 !important;
    background: #f4fef7 !important;
	padding: 5px 10px;
    display: inline-block;
    border-radius: 30px;
    font-weight: bold;
    float: left;
    margin-right: 2%;
}
 .cross-mark{
        background:  #c2c2c2;
        padding: 0px 5px;
        border-radius: 100%;
        cursor: pointer;
}
.remove-doc{
        color: #D0032E;;
        font-size: 12px;
        font-style: italic;
        font-weight: bolder;
        text-decoration: underline;
        /* float: right; */
}
.add-doc{
    font-size: 12px;
    font-style: italic;
    font-weight: bolder;
    text-decoration: underline;
    color: #4A92E8;
}
.training_plan_border{
    border-bottom: 1px dashed #c2c2c2;
    margin-bottom: 10px;
}



.document-list {
    padding: 15px 10px 15px 0;
}
.document-list__header {
    position: relative;
}
.document-list__heading {
    padding: 5px 10px;
    display: inline-block;
    border-radius: 30px;
    font-weight: 600;
    float: left;
    padding-right: 5px;
     border: none;
    background: none;


}
.document-list__heading i {
    font-size: 22px;
    padding-right: 10px;
}

.document-list__controls {
    float: right;
}

.warning-content{
    font-weight: 600;
    font-size: 16px;
    padding-top: 10px;
    padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/FormI983/FileView.vue